import React from "react";
import { forEach } from "lodash";
import { connect } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { Button, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import moment from 'moment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import { insertToIndex } from '../../../../global/globalFunctions'
import {
    Row,
    FormGroup,
    Label,
    Input,

    Col,
    Collapse,


    ModalBody,

    Modal,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";
import { Input as MInput } from '@material-ui/core/';
import { isEmpty, remove, isUndefined, filter, size, find, replace } from "lodash";
import {
    AlignmentType,
    convertInchesToTwip,
    Document,
    HeadingLevel,
    LevelFormat,
    Packer,
    Paragraph,
    TextRun,

    upperRoman,

    Footer,
    PageNumber,
    PageBreak,
    decimal,
    BULLET,
    Table,
    TableRow,
    TableCell,
    WidthType,
} from "docx";
import { saveAs } from 'file-saver';
import { IndeterminateCheckBoxOutlined } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import {
    maritalSettlemenAgreement,
} from "../maritalSettlementAgreements/maritalSettlement.action";
import {
    postData,
    petitionerReceice,
    divisionDebts,
    equalizationPayment,
    transferRetirement,
    prentingPlan,
    regularSchedule,
    holidaySchedule,
    summerSchedule,
    spousalSupport,
    maritalSettlementGetAllData,
} from "../maritalSettlementAgreements/maritalSettlement.action";
import Loader from "react-loader-spinner";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";


const MaritalSettlement = (props) => {
    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;
    const dates = props.dates;
    const dissolveMarriage = props.isDissolveMarriage;
    const assetRespondent = props.assetRespondent;
    const childData = props.childData;
    const oweEqualizationPayment = props.oweEqualizationPayment.val;
    const owesPayment = props.owesPayment.val;
    const spouseOwe = props.spouseOwe.val;
    const test1 = owesPayment === "1" ? `${respondentDetails.firstName} ${respondentDetails.lastName} to ${petitionerDetails.firstName} ${petitionerDetails.lastName}` : `${petitionerDetails.firstName} ${petitionerDetails.lastName} to ${respondentDetails.firstName} ${respondentDetails.lastName}`;
    const paymentDue = props.paymentDue.amount;
    const test2 = paymentDue === "1" ? `${moment(props.paymentDue.date).format('LL')}` : `${props.paymentDue.val}`;
    const interestAccrueAmount = props.interestAccrue.amount;
    const interestAccrue = props.interestAccrue.val;
    const testinterestAccrue = `${interestAccrueAmount}` === "1" ? `In order to equalize the division of the community assets and debts, ${petitionerDetails.firstName} ${petitionerDetails.lastName} shall pay ${respondentDetails.firstName} ${respondentDetails.lastName} the sum of $${spouseOwe} due on ${test2}. Should any portion be unpaid by the due date, the unpaid portion shall accrue interest at the rate of ${interestAccrue}%  per annum. Once the equalization payment of $${spouseOwe} is made from ${test1}, and any accrued interest, the division of the community estate is fair, equal and agreed to by the parties.` : `•  In order to equalize the division of the community assets and debts,  ${petitionerDetails.firstName} ${petitionerDetails.lastName} shall pay ${respondentDetails.firstName} ${respondentDetails.lastName} the sum of $${spouseOwe} due on ${test2}. No interest shall accrue interest on the unpaid balance. Once the equalization payment of $${spouseOwe} is made from ${test1}, the division of the community estate is fair, equal and agreed to by the parties.`;
    const petitionerCheck = props.petitionerCheck;
    const transferRetirementValue = props.transferRetirementValue.amount;
    const requireQdro = props.requireQdro.amount;
    const test3 = `${requireQdro}` === "1" ? `In order to complete the transfer of retirement assets in Section 2., Division of Property, the parties shall commence the QDRO process, for the retirement transfers requiring a QDRO, within 60 days of executing this Agreement and cooperate with one another to complete the process as soon as practical. Each party shall be responsible for one-half of the QDRO fees and costs, including the QDRO attorney and any fees to complete the transfers from these retirement plans. For any retirement transfers that do not require a QDRO, with the assistance of the financial institution, the owner of the retirement account shall rollover the funds owed to the other party to a rollover retirement in that party’s name within 60 days of executing the Agreement. After all the rollovers/transfers are completed, each party is awarded all retirement assets in his or her name.` : `•  In order to complete the transfer of retirement assets in Section 2., Division of Property, with the assistance of the financial institution, the owner of the retirement account shall rollover the funds owed to the other party to a rollover retirement in that party’s name within 60 days of executing the Agreement. After all the rollovers are completed, each party is awarded all retirement assets in his or her name.`;
    const minorChildren = props.minorChildren.amount;
    const regularScheduleValue = props.regularScheduleValue;
    const commencingDate = moment(props.commencingDate.date).format('LL');
    const petitionalShall = props.petitionalShall.val;
    const respondentShall = props.respondentShall.val;
    const partiesShall = props.partiesShall.val;
    const custodyShall = props.custodyShall.val;
    const parentShall = props.parentShall.val;
    const scheduleDate = moment(props.scheduleDate.date).format('LL');
    const weekPetitionalShall = props.weekPetitionalShall.val;
    const weekRespondentShall = props.weekRespondentShall.val;
    const alternateMonday = props.alternateMonday.val;
    const alternateWeekend = props.alternateWeekend.val;
    const remainFlexible = props.remainFlexible.val;
    const test4 = props.holidayScheduleVal.amount;
    const test6 = props.spousalRespondent.amount;
    const spousalRespondentDate = props.spousalRespondent.date
    const spouseShall = props.spouseShall.amount;
    const spouseShallDate = props.spouseShall.date
    console.log(spouseShallDate, props.spouseShall.date, "date")
    const test7 = `${spouseShall}` === "0" ? `Spousal support shall continue month to month until death of either party, Petitioner’s remarriage, further order of the court or agreement, or ${spouseShallDate} ,  at which date it shall terminate. No further spousal support shall be owed from Respondent to Petitioner after ${spouseShallDate}  , which shall be non-modifiable termination date.` : `Respondent shall pay Petitioner as permanent spousal support $${props.spousalRespondent.permanent} per month. Support shall begin on ${spousalRespondentDate}. Support payments shall be paid ½ on the 1st and ½ on the 15th of each month. Spousal support shall continue month to month until death of either party, Petitioner’s remarriage, further order of the court or agreement. The parties have agreed that there shall be no termination date at this time.`;
    const reservation = props.reservation.amount;
    const reservationDate = props.reservation.date
    const test8 = `${reservation}` === "0" ? `Reserving the Court’s Jurisdiction and Setting of Support to Zero to Petitioner. Spousal support from Petitioner to Respondent  is reserved to ${reservationDate}, Petitioner’s remarriage, death of either party, or further court order or stipulated agreement. At the earliest of these times, the court shall no longer have the authority to award spousal support to Petitioner. No spousal support from Petitioner to Respondent is due at this time.  Any spousal support payable to Petitioner from Respondent shall terminate on ${reservationDate}, and the Court shall not have jurisdiction to award any spousal support to Petitioner from Respondent after  ${reservationDate}. The waiver of spousal support after ${reservationDate}, is a binding, voluntary, mutual, permanent, non-modifiable, termination of spousal support, and with full knowledge. Petitioner had an opportunity to consult with an attorney regarding this waiver.  Petitioner understands when the court terminates its jurisdiction on ${reservationDate}, the Court no longer has the authority or power to award spousal support to Petitioner.` : `Reserving the Court’s Jurisdiction and Setting of Support to Zero to Petitioner.  Spousal support from Petitioner to Respondent  is reserved until Petitioner’s remarriage, death of either party,or further court order or stipulated agreement. At the earliest of these times, the court shall no longer have the authority to award spousal support to Petitioner. No spousal support from Petitioner to Respondent is due at this time. `;

    const test9 = props.spousalPetitioner.amount;
    const spousalPetitionerDate = props.spousalPetitioner.date
    const spousalShall = props.spousalShall.amount;
    const spousalShallDate = props.spousalShall.date
    const test10 = `${spousalShall}` === "0" ? `  Spousal support shall continue month to month until death of either party, Respondent’s remarriage, further order of the court or agreement, or ${spousalShallDate},  at which date it shall terminate. No further spousal support shall be owed from Petitioner to Respondent after ${spousalShallDate}, which shall be non-modifiable termination date.` : `Petitioner shall pay Respondent as permanent spousal support $${props.spousalPetitioner.permanent} per month. Support shall begin on ${spousalPetitionerDate}. Support payments shall be paid ½ on the 1st and ½ on the 15th of each month. Spousal support shall continue month to month until death of either party, Respondent’s remarriage, further order of the court or agreement. The parties have agreed that there shall be no termination date at this time.`;
    const resReservation = props.resReservation.amount;
    const resReservationDate = props.resReservation.date
    const test11 = `${resReservation}` === "0" ? `Reserving the Court’s Jurisdiction and Setting of Support to Zero to Respondent. Spousal support from Respondent to Petitioner  is reserved to ${resReservationDate}, Respondent’s remarriage, death of either party, or further court order or stipulated agreement. At the earliest of these times, the court shall no longer have the authority to award spousal support to the Respondent. No spousal support from Respondent to Petitioner is due at this time.  Any spousal support payable to Respondent from Petitioner shall terminate on  ${resReservationDate}, and the Court shall not have jurisdiction to award any spousal support to Respondent from Petitioner after ${resReservationDate}. The waiver of spousal support after  ${resReservationDate}, is a binding, voluntary, mutual, permanent, non-modifiable, termination of spousal support, and with full knowledge. Respondent had an opportunity to consult with an attorney regarding this waiver.  Respondent understands when the court terminates its jurisdiction on ${resReservationDate}, the Court no longer has the authority or power to award spousal support to Respondent. ` : `Reserving the Court’s Jurisdiction and Setting of Support to Zero to Respondent.  Spousal support from Respondent to Petitioner  is reserved until Respondent’s remarriage, death of either party,or further court order or stipulated agreement. At the earliest of these times, the court shall no longer have the authority to award spousal support to Respondent. No spousal support from Respondent to Petitioner is due at this time.`;

    const [personName, setPersonName] = React.useState(isUndefined(props.regularScheduleValue.day) || isEmpty(props.regularScheduleValue.day) ? [] : props.regularScheduleValue.day);


    console.log(courtDetails, "aaaaaaaaaaaaaaaaa")
    const handleChangeChip = (event) => {
        setPersonName(event.target.value);
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 450,
            },
        },
    };
    const names = [
        'Saturday',
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
    ];
    function getStyles(name, personName, theme) {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    };
    const theme = useTheme();

    //•  All

    const propAwardtoPet = [{
        id: "1",
        text: 'All checking, savings, money market, and all other financial accounts in Petitioner’s name.'

    },
    {
        id: "2",
        text: 'Any and all retirement accounts in Petitioner’s name.'
    },
    {
        id: "3",
        text: 'Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits in Petitioner’s name.'

    },
    {
        id: "4",
        text: 'All clothing, jewelry, and personal effects in Petitioner’s possession.'

    },
    {
        id: "5",
        text: 'Any credit card points, reward credits, and airline miles in Petitioner’s name.'

    },
    {
        id: "6",
        text: 'Minimal cash in Petitioner’s possession'

    },

    ]
    const propAwardtoRes = [{
        id: "7",
        text: 'All checking, savings, money market, and all other financial accounts in Respondent’s name.'
    },
    {
        id: "8",
        text: 'Any and all retirement accounts in Respondent’s name.'
    },
    {
        id: "9",
        text: 'Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits.'

    },
    {
        id: "10",
        text: 'All clothing, jewelry, and personal effects in Respondent’s possession'

    },
    {
        id: "11",
        text: 'Any credit card points, reward credits, and airline miles in Respondent’s name.'

    },
    {
        id: "12",
        text: 'Minimal cash in Respondent’s possession.'

    },

    ]
    const debtsAwardPet = [{
        id: "13",
        text: 'Petitioner shall be responsible for any and all obligations (debts) in Petitioner’s name.'
    },
    {
        id: "14",
        text: 'Petitioner shall be responsible for any and all credit card debts in Petitioner’s name.'
    },
    {
        id: "15",
        text: 'Petitioner shall be responsible for any and all school loans in Petitioner’s name.'

    },

    ]
    const debtsAwardRes = [{
        id: "16",
        text: 'Respondent shall be responsible for any and all obligations (debts) in Respondent’s name.'
    },
    {
        id: "17",
        text: 'Respondent shall be responsible for any and all credit card debts in Respondent’s name.'
    },
    {
        id: "18",
        text: 'Respondent shall be responsible for any and all school loans in Respondent’s name.'

    },

    ]
    const propAwardtoPet4 = [{
        id: "19",
        text: 'The parties shall cooperate in canceling all joint credit cards and store accounts. '
    },
    {
        id: "20",
        text: 'Neither party shall make any further charges on any credit card or store account for which the other party is or may be liable.'
    }

    ]
    let filteredArarypropAwardtoPet = filter(propAwardtoPet, x => props.generalProvisionsPetitioner.val.includes(x.id));
    let filteredArarypropAwardtoRes = filter(propAwardtoRes, x => props.generalProvisionsRespondent.val.includes(x.id));
    let filteredAraryDebtsPetitioner = filter(debtsAwardPet, x => props.provisionsPetitioner.val.includes(x.id));
    let filteredAraryDebtsRespondent = filter(debtsAwardRes, x => props.provisionsRespondent.val.includes(x.id));
    let filteredAraryAdditionalLanguage = filter(propAwardtoPet4, x => props.addtionLanguage.val.includes(x.id));
// Constants (adjust based on document settings)
const PAGE_HEIGHT = 842; // A4 page height in points (approx. 11 inches * 72 points per inch)
const MARGIN_TOP_BOTTOM = 72 + 72; // 1-inch top and bottom margin (72 points each)
const USABLE_HEIGHT = PAGE_HEIGHT - MARGIN_TOP_BOTTOM;
const LINE_HEIGHT = 24; // Approximate line height (depends on font size)

// Calculate total lines per page
const TOTAL_LINES_PER_PAGE = Math.floor(USABLE_HEIGHT / LINE_HEIGHT);

// Function to calculate remaining lines
const getRemainingLines = (linesUsed) => Math.max(TOTAL_LINES_PER_PAGE - linesUsed, 0);

// Function to generate // for remaining space

const linesUsed = 5;
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },

        formControl: {
            marginTop: theme.spacing(2),
            margin: theme.spacing(1),
            minWidth: 300,
            maxWidth: 400,
        },
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },

    }));

    useEffect(() => {

        props.postData({ divorce_id: window.localStorage.getItem("divorce_id") });
        props.maritalSettlementGetAllData({ divorce_id: window.localStorage.getItem("divorce_id") });

    }, []);

    const [isMaritalOne, setMaritalOne] = useState(props.owesPayment.val === 1 ? 1 : 0);
    const [isMaritalTwo, setMaritalTwo] = useState(props.interestAccrue.amount === 1 ? 1 : 0);
    const [isMaritalThree, setMaritalThree] = useState(props.minorChildren.amount === 1 ? 1 : 0);
    const [isMaritalFour, setMaritalFour] = useState(false);
    const [isMaritalFive, setMaritalFive] = useState(props.regularScheduleValue.amount);
    const [isMaritalSix, setMaritalSix] = useState(props.holidayScheduleVal.amount);
    const [isMaritalSeven, setMaritalSeven] = useState(props.summerScheduleVal.amount);
    let ze = props.summerScheduleVal.amount;
    const [isMaritalEight, setMaritalEight] = useState(props.spousalRespondent.amount);
    const [isMaritalNine, setMaritalNine] = useState(props.reservation.amount);
    const [isMaritalTen, setMaritalTen] = useState("");
    const [isMaritalEleven, setMaritalEleven] = useState(props.spousalPetitioner.amount);
    const [isMaritalTwelve, setMaritalTwelve] = useState(props.spouseShall.amount);
    const [isMaritalThirdteen, setMaritalThirdteen] = useState(props.spousalShall.amount);
    const [isMaritalForteen, setMaritalForteen] = useState(props.resReservation.amount);
    const [isMaritalFifteen, setMaritalFifteen] = useState(props.paymentDue.amount === 1 ? 1 : 0);
    const [isMaritalSixteen, setMaritalSixteen] = useState(props.oweEqualizationPayment.val === 1 ? 1 : 0);
    const [isMaritalSeventeen, setMaritalSeventeen] = useState(props.transferRetirementValue.amount === 1 ? 1 : 0);
    const [isMaritalTextOne, setMaritalTextOne] = useState("");
    const [show, setShow] = useState(false);
    const [finalShow, setFinalShow] = useState(false);
    const [FL, setFL] = useState((isEmpty(props.generalProvisionsPetitioner.val) && isEmpty(props.generalProvisionsRespondent.val) && isEmpty(props.provisionsPetitioner.val) && isEmpty(props.provisionsRespondent.val) && isEmpty(props.addtionLanguage.val)) ? [] : props.generalProvisionsPetitioner.val.concat(props.generalProvisionsRespondent.val).concat(props.provisionsPetitioner.val).concat(props.provisionsRespondent.val).concat(props.addtionLanguage.val));
    const [inputFieldsSecond, setInputFieldsSecond] = useState(isEmpty(props.otherAssetRespondent) ? [{ second: '' }] : props.otherAssetRespondent.map(val => ({ 'second': replace(val, /wewewe/g, ",") })));
    const [inputFieldsThird, setInputFieldsThird] = useState(isEmpty(props.debtsPetitioner.val) ? [{ third: '' }] : props.debtsPetitioner.val.map(val => ({ 'third': replace(val, /wewewe/g, ",") })));
    const [inputFieldsForth, setInputFieldsForth] = useState(isEmpty(props.assetRespondent.val) ? [{ forth: '' }] : props.assetRespondent.val.map(val => ({ 'forth': replace(val, /wewewe/g, ",") })));
    const [inputFieldsFive, setInputFieldsFive] = useState(isEmpty(props.childData) ? [{ childName: "", legalCustody: "", soleCustody: "" }] : props.childData);

    const [inputFields, setInputField] = useState(isEmpty(props.otherAssetPetitioner) ? [{ first: '' }] :
        props.otherAssetPetitioner.map(val => ({ 'first': replace(val, /wewewe/g, ",") })));

    const handleChangeInput = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.id] = event.target.value;
        setInputField(values);

    }
    const handleAddFields = () => {
        setInputField([...inputFields, { first: "" }])
    }

    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        if (index = -1)
            values.splice(index, 1);
        setInputField(values);
    }
    // Function 2
    const handleChangeInput1 = (index, event) => {
        const values = [...inputFieldsSecond];
        values[index][event.target.id] = event.target.value;
        setInputFieldsSecond(values);

    }
    const handleAddFields1 = () => {
        setInputFieldsSecond([...inputFieldsSecond, { second: "" }])
    }

    const handleRemoveFields1 = (index) => {
        const values = [...inputFieldsSecond];
        if (index = 1)
            values.splice(index, 1);
        setInputFieldsSecond(values);
    }

    // Function 3
    const handleChangeInput2 = (index, event) => {
        const values = [...inputFieldsThird];
        values[index][event.target.id] = event.target.value;
        setInputFieldsThird(values);

    }
    const handleAddFields2 = () => {
        setInputFieldsThird([...inputFieldsThird, { third: "" }])
    }

    const handleRemoveFields2 = (index) => {
        const values = [...inputFieldsThird];
        if (index = 1)
            values.splice(index, 1);
        setInputFieldsThird(values);
    }

    // Function 4
    const handleChangeInput3 = (index, event) => {
        const values = [...inputFieldsForth];
        values[index][event.target.id] = event.target.value;
        setInputFieldsForth(values);

    }
    const handleAddFields3 = () => {
        setInputFieldsForth([...inputFieldsForth, { forth: "" }])
    }

    const handleRemoveFields3 = (index) => {
        const values = [...inputFieldsForth];
        if (index = 1)
            values.splice(index, 1);
        setInputFieldsForth(values);
    }

    // Function 5
    const handleChangeInput4 = (index, event) => {
        const values = [...inputFieldsFive];
        values[index][event.target.id] = event.target.value;
        setInputFieldsFive(values);

    }
    const handleAddFields4 = () => {
        setInputFieldsFive([...inputFieldsFive, { childName: "", legalCustody: "", soleCustody: "" }])
    }

    const handleRemoveFields4 = (index) => {
        const values = [...inputFieldsFive];
        if (index = 1)
            values.splice(index, 1);
        setInputFieldsFive(values);
    }

    let filteredArarypropAwardtoPetFinal = [];
    forEach(filteredArarypropAwardtoPet, val =>
        filteredArarypropAwardtoPetFinal.push(new TextRun({
            text: `${val.text}`,
            break: 1,
            numbering: {
                reference: "my-crazy-numbering",
                level: 3,
            },
        })));

    let otherAssetsPetitionerArray = [];
    console.log(props.otherAssetPetitioner, "newtest")
    forEach(props.otherAssetPetitioner, val =>
        otherAssetsPetitionerArray.push({
            text: val
        }));


    let filteredArarypropAwardtoResFinal = [];
    forEach(filteredArarypropAwardtoRes, val =>
        filteredArarypropAwardtoResFinal.push({
            text: `${val.text}`,
            break: 1,
        }));

    let otherAssetsRespondentArray = [];
    forEach(props.otherAssetRespondent, val =>
        otherAssetsRespondentArray.push({
            text: `${replace(val, /wewewe/g, ",")}`,
            break: 1,
        }));

    let filteredAraryDebtsPetitionerFinal = [];
    forEach(filteredAraryDebtsPetitioner, val =>
        filteredAraryDebtsPetitionerFinal.push({
            text: `${val.text}`,
        }));

    let filteredAraryDebtsRespondentFinal = [];
    forEach(filteredAraryDebtsRespondent, val =>
        filteredAraryDebtsRespondentFinal.push({
            text: `${val.text}`,
            break: 1,
        }));



    let filteredArarydebtsPetitionerFinal = [];
    forEach(props.debtsPetitioner.val, val =>
        filteredArarydebtsPetitionerFinal.push({
            text: `${replace(val, /wewewe/g, ",")}`,
        })
    );

    let filteredAraryassetRespondentFinal = [];
    forEach(props.assetRespondent.val, val =>
        filteredAraryassetRespondentFinal.push({
            text: `${replace(val, /wewewe/g, ",")}`
        })
    );
    let filteredAraryAdditionalLanguageFinal = [];
    forEach(filteredAraryAdditionalLanguage, val =>
        filteredAraryAdditionalLanguageFinal.push({
            text: `${val.text}`,

        }));

    let childDataArrayName = [];
    let childDataArrayLc = [];
    let childDataArraySc = [];
    forEach(props.childData, val => {
        childDataArrayName.push(new Paragraph(`${val.childName}`));
        childDataArrayLc.push(new Paragraph(`${val.legalCustody}`));
        childDataArraySc.push(new Paragraph(`${val.soleCustody}`))

    });

    const handleShow = () => {
        setShow(true)
    }

    function getCheckedValue(value) {
        if (FL.includes(value)) {
            let dummyArray = FL;
            remove(dummyArray, function (val) {
                return val === value;
            });
        } else {
            let dummyArray = FL;
            dummyArray.push(value);
            setFL(dummyArray);
        }
    }

    const handleClose = () => setShow(false);
    let arrayMid = [];
    let arrayFirst = [];
    let arrayLast = [];
    let finalPetArray = filteredArarypropAwardtoPet.concat(otherAssetsPetitionerArray)
    let finalResArray = filteredArarypropAwardtoRes.concat(otherAssetsRespondentArray)
    let finalPetDebtsArray = filteredAraryDebtsPetitionerFinal.concat(filteredArarydebtsPetitionerFinal)
    let finalResDebtsArray = filteredAraryDebtsRespondentFinal.concat(filteredAraryassetRespondentFinal, filteredAraryAdditionalLanguageFinal)
    function printxy(){
        return [
            new Paragraph({ text:"//"}), new Paragraph({ text:"//"})
        ]
    }

    let firstArrayList = [];
    forEach(finalPetArray, x => {
        firstArrayList.push(new Paragraph({
            // children: filteredArarypropAwardtoPetFinal.concat(otherAssetsPetitionerArray),
            text: x.text,
            style: "numSpace",
            numbering: {
                reference: "my-crazy-numbering",
                level: 5,
            },
        }))
    })


    firstArrayList.push(new Paragraph({
        children: [
            new TextRun({
                text: `Property Awarded or Confirmed to ${respondentDetails.firstName}.`,
                underline: {},
                bold: true,
            }),
        ],
        numbering: {
            reference: "my-crazy-numbering",
            level: 2,
        },
        style: "num",
    }))


    forEach(finalResArray, x => {
        firstArrayList.push(new Paragraph({
            // children: filteredArarypropAwardtoPetFinal.concat(otherAssetsPetitionerArray),
            text: x.text,
            style: "numSpace",
            numbering: {
                reference: "my-crazy-numbering",
                level: 5,
            },
        }),)
    })


    firstArrayList.push(new Paragraph({
        text: `  Debts`,
        numbering: {
            reference: "my-crazy-numbering",
            level: 0,
        },
        style: "aside",
    }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `Debts Awarded or Confirmed to ${petitionerDetails.firstName}.`,
                    underline: {},
                    bold: true,
                }),
                new TextRun({
                    text: ` Petitioner shall indemnify and hold Respondent harmless against any liability for these debts.  `,
                    underline: false,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "asidenew"
        }),)
    forEach(finalPetDebtsArray, x => {
        firstArrayList.push(new Paragraph({

            text: x.text,
            style: "numSpace",
            numbering: {
                reference: "my-crazy-numbering",
                level: 5,
            },
        }),)
    })

    firstArrayList.push(new Paragraph({
        children: [
            new TextRun({
                text: ` Debts Awarded or Confirmed to ${respondentDetails.firstName}.`,
                underline: {},
                bold: true,
            }),
            new TextRun({
                text: " Respondent  shall indemnify and hold Petitioner harmless against any liability for these debts. ",
                underline: false,
            })
        ],
        numbering: {
            reference: "my-crazy-numbering",
            level: 2,
        },
        style: "asidenew",
    }),
    )
    forEach(finalResDebtsArray, x => {
        firstArrayList.push(new Paragraph({

            text: x.text,
            style: "numSpace",
            numbering: {
                reference: "my-crazy-numbering",
                level: 5,
            },
        }),)
    })

    arrayMid.push(
        new Paragraph({
            text: `  Parenting Plan`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Custody of the minor children of the parties is awarded as follows:`,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside3",
        }),




        new Table({
            columnWidths: [3505, 5505],
            rows: [
                new TableRow({
                    children: [
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: [new Paragraph({
                                text:
                                    "Child Name",
                            }),],

                        }),
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: [new Paragraph({
                                text:
                                    "Legal Custody",

                            }),],
                        }),
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: [new Paragraph({
                                text:
                                    "Physical custody",

                            }),],
                        }),
                    ],
                }),
                new TableRow({
                    children: [
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: childDataArrayName,
                        }),
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: childDataArrayLc,
                        }),
                        new TableCell({
                            width: {
                                size: 3505,
                                type: WidthType.DXA,
                            },
                            children: childDataArraySc,
                        }),
                    ],
                }),
            ],
            break: 1,
            style: "tableStyle",
        }),

        new Paragraph({
            text: `Time Sharing Schedules`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside3",
        }),




        props.regularScheduleValue.amount === 0 ? new Paragraph({
            text: `Regular Schedule: Commencing ${moment(props.regularScheduleValue.date).format('LL')}, the parties shall alternate physical custody of the children on a week on and week off basis. The parties shall exchange the children at ${regularScheduleValue.time} on ${regularScheduleValue.day}. The parties shall exchange at: ${regularScheduleValue.val}. The parties shall remain flexible with one another to make adjustments to the schedule as needed, and in their children’s best interests.`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }) : props.regularScheduleValue.amount === 1 ?
            new Paragraph({
                //text: `Holiday Schedule: We will not specify the schedule, but agree to share holidays so that each of us receives equal custodial time either by sharing all the holidays, alternating or some other agreed to method.`,
                children: [
                    new TextRun({
                        text: `Regular Schedule: Commencing ${scheduleDate}, the parties shall share physical custody of the children for the Regular or School Schedule as follows (also referred to as a 2-2-3 schedule)`,

                    }),
                    new TextRun({
                        text: `• ${weekPetitionalShall}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `• ${weekRespondentShall}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `• ${alternateMonday}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `• ${alternateWeekend}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `• ${remainFlexible}`,
                        break: 1
                    })
                ],
                numbering: {
                    reference: "my-crazy-numbering",
                    level: 7,
                },
                style: "aside1",
            }) : props.regularScheduleValue.amount === 2 ?
                new Paragraph({
                    children: [
                        new TextRun({
                            text: `Regular Schedule: Commencing ${commencingDate} , the parties shall share physical custody on a 2-2-5-5 schedule, as follows:`,

                        }),
                        new TextRun({
                            text: `• ${petitionalShall}`,
                            break: 1
                        }),
                        new TextRun({
                            text: `• ${respondentShall}`,
                            break: 1
                        }),
                        new TextRun({
                            text: `• ${partiesShall}`,
                            break: 1
                        }),
                        new TextRun({
                            text: `• ${custodyShall}`,
                            break: 1
                        }),
                        new TextRun({
                            text: `• ${parentShall}`,
                            break: 1
                        })
                    ],
                    numbering: {
                        reference: "my-crazy-numbering",
                        level: 7,
                    },
                    style: "aside1",
                }) :
                new Paragraph({
                    text: `Regular Schedule: ${props.regularOther.val}`,
                    numbering: {
                        reference: "my-crazy-numbering",
                        level: 7,
                    },
                    style: "aside1",
                }),
        // holiday here

        props.holidayScheduleVal.amount === 0 ? new Paragraph({
            text: `Holiday Schedule: We will not have a Holiday Schedule`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }) : props.holidayScheduleVal.amount === 1 ?
            new Paragraph({
                text: `Holiday Schedule: We will not specify the schedule, but agree to share holidays so that each of us receives equal custodial time either by sharing all the holidays, alternating or some other agreed to method.`,
                numbering: {
                    reference: "my-crazy-numbering",
                    level: 7,
                },
                style: "aside1",
            }) : props.holidayScheduleVal.amount === 2 ?
                new Paragraph({
                    text: `Holiday Schedule: We have a Holiday Schedule that we will include as an attachment to the MSA.`,
                    numbering: {
                        reference: "my-crazy-numbering",
                        level: 7,
                    },
                    style: "aside1",
                }) :
                new Paragraph({
                    text: `Holiday Schedule: ${props.holidayScheduleVal.val}`,
                    numbering: {
                        reference: "my-crazy-numbering",
                        level: 7,
                    },
                    style: "aside1",
                }),


        //       test4 === 0 &&  new Paragraph({
        //             children: [
        //                 new TextRun({
        //                     text: `${test4}` === "0" ? `None` : "",
        //                 }),

        //             ],
        //             numbering: {
        //                 reference: "my-crazy-numbering",
        //                 level: 8,
        //             },
        //             style: "aside1",
        //         }),
        //       new Paragraph({
        //             children: [
        //                 new TextRun({
        //                     text: `${test4}` === "1" ? `The parties agree to share the holidays so that each parent receives equal custodial time either by sharing all the holidays in the year, alternating or some agreed to method. The parties shall jointly identify what holidays are included in the Holiday Schedule, including the start and end times.` : "",
        //                 }),

        //             ],
        //             numbering: {
        //                 reference: "my-crazy-numbering",
        //                 level: 8,
        //             },
        //             style: "aside1",
        //         }),

        //   new Paragraph({
        //             children: [
        //                 new TextRun({
        //                     text: `${test4}` === "2" ? `The parties shall share physical custody of the children on the holidays as agreed to in the Holiday Schedule, attached and incorporated herein.` : "",
        //                 }),

        //             ],
        //             numbering: {
        //                 reference: "my-crazy-numbering",
        //                 level: 8,
        //             },
        //             style: "aside1",
        //         }),
        //         new Paragraph({
        //             children: [
        //                 new TextRun({
        //                     text: `${test4}` === "3" ? ` ${props.holidayScheduleVal.val}` : "",
        //                 }),

        //             ],
        //             numbering: {
        //                 reference: "my-crazy-numbering",
        //                 level: 8,
        //             },
        //             style: "aside1",
        //         }),

        props.summerScheduleVal.amount === 0 ? new Paragraph({
            text: `SummerSchedule/Summer Vacation: We will not have a Summer Schedule. (Is not different from the Regular Schedule and we are not including any vacation time.`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }) : props.summerScheduleVal.amount === 1 ?
            new Paragraph({
                text: `SummerSchedule/Summer Vacation: During the children summer vacation, each party shall have the right to ${props.summerScheduleVal.summer} days of summer vacation time, which may be taken as up to ${props.summerScheduleVal.consecutive} consecutive days including the regular custodial time and [does or does not] require travel. The parties shall select their dates by April 1st of that year. The parents shall alternate the years in which the parent has priority to select his/her dates. Petitioner shall have even years; Respondent shall have odd years.`,
                numbering: {
                    reference: "my-crazy-numbering",
                    level: 7,
                },
                style: "aside1",
            }) :
            new Paragraph({
                text: `SummerSchedule/Summer Vacation: ${props.summerScheduleVal.other}`,
                numbering: {
                    reference: "my-crazy-numbering",
                    level: 7,
                },
                style: "aside1",
            }),



        new Paragraph({
            children: [
                new TextRun({
                    text: `Joint Decision Making:`,
                    italics: true,
                }),
                new TextRun({
                    text: ` parents shall cooperate and must jointly agree prior to make decisions on the following: `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),

        new Paragraph({
            text: `Enrolment or withdrawing from:`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Any schooling;`,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 8,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Extracurricular activities; and`,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 8,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Mental health treatment or therapy.`,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 8,
            },
            style: "aside1",
        }),

        new Paragraph({
            text: `Authorizing a child’s driver’s permit or license;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),

        new Paragraph({
            text: `Changing a child’s residence from the current county;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Changing a child’s first or last name;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Obtaining or changing a child’s phone number;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Authorizing any social media account(s) for the children;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Applying for, or renewing passports;`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Child working; and`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `Nonemergency medical and dental treatment (except for routine checkups).`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `In emergency situations, the custodial parent has the right to make decisions necessary to protect the children. `,
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `Sharing of Legal Responsibilities`,
                    italics: true,
                }),
                new TextRun({
                    text: `: Both parents shall keep the other informed by sharing a joint calendar. This might mean that the parties create a third email account to use for parenting issues. The parents shall cooperate to divide the responsibilities for the children’s schedules.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Move Away`,
                    italics: true,
                }),
                new TextRun({
                    text: `: The parties agree that a move up to a maximum of 15 miles is acceptable provided the move does not result in a change of school for the children, otherwise a “move away” will be triggered and the move will require either the agreement of both parties or a court order. `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Child Care`,
                    italics: true,
                }),
                new TextRun({
                    text: `: If either parent opts to use child care for the children, the parties agree that the child care provider must be from the parents’ preapproved child care list. If the parent requires to use another provider, the parents must first agree prior to use and shall add the name to their list. This does not include or apply to family members. `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Firearms`,
                    italics: true,
                }),
                new TextRun({
                    text: `: If either parent stores firearms at his or her residence, the party must store the firearms in accordance with federal or state laws, including storing the firearm in a locked and unloaded with the ammunition in a separate location. The parties must mutually agree to any activities using firearms such as practicing in a shooting range. `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Children’s Health`,
                    italics: true,
                }),
                new TextRun({
                    text: `: Absent another agreement, the custodial parent shall be responsible for any sick child during his or her custodial time. In addition, the parents shall exchange all information about the children’s health directly with each other as soon as practical, which may be by text messaging.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Exchange of Important Information`,
                    italics: true,
                }),
                new TextRun({
                    text: `: The parents shall keep each other promptly informed of information related to the children, including health, school, extracurriculars or other areas regarding their wellbeing. Each parent is entitled to receive information directly from the school. The parents shall not use the children as messengers to pass messages between them; and not discuss legal or financial issues involving the parents or children during the exchanges. The parents shall also keep each other informed of their telephone number and any other contact information, should it change.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Screen Time (TV, Social Media and Gaming)`,
                    italics: true,
                }),
                new TextRun({
                    text: `: The parents agree that they shall cooperate to limit the children’s usage of screens. Prior to either child obtaining a social media account or starting any video/computer games, both parents must specifically approve the social media application or game. At least one parent shall monitor the accounts, including having the login and password or the application on his/her phone. For any electronics in which the children have access, the parents shall install and maintain parental controls on those devices.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Romantic Interests`,
                    italics: true,
                }),
                new TextRun({
                    text: `:  The parties agree that they will use their own best judgment as to the timing of introducing a romantic partner to the children but will inform the other party prior to introducing to the children.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Right of First Refusal`,
                    italics: true,
                }),
                new TextRun({
                    text: `:  If either parent is away for one overnight or more from the children during his or her custodial time, that parent must offer the time to the other parent before using other care.  Reasonable notice must be provided so that the other parent can adjust his/her schedule in order to accommodate the children.  The other parent must respond within a reasonable time whether or not they can take the children on their non-custodial time. If the non-custodial parent is unable or does not respond within a reasonable time, the parent is free to use other care.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Changing Parenting Plan`,
                    italics: true,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `By Agreement`,
                    italics: true,
                }),
                new TextRun({
                    text: `: The parties have agreed to a simplified approach to modify their Parenting Plan. If the parties agree to change any provision, including the Regular, Summer or Holiday Schedule, they may do so by a mutual signed agreement. A court order is not required. However, if the change is temporary (such as adjusting a pick up time or location), a simple email or text exchange is sufficient, such as language to the effect: “Agreed?” or “Yes, agreed.” `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `No agreement`,
                    italics: true,
                }),
                new TextRun({
                    text: `: Should the parents be unable to agree regarding a modification to the parenting plan, they agree to attend custody mediation with a mutually agreeable professional. Thereafter, either party may request relief from the court. Until there is an agreement or further court order, the Parenting Plan remains in effect. This provision shall not apply in emergency situations. `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 7,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Jurisdiction`,
                    italics: true,
                }),
                new TextRun({
                    text: `:  The court has jurisdiction to make child custody orders in this case under the Uniform Child Custody Jurisdiction and Enforcement Act (part 3 of the California Code, commencing with Section 3400).
                `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Notice and opportunity to be heard`,
                    italics: true,
                }),
                new TextRun({
                    text: `:  The responding party was given notice and an opportunity to be heard, as provided by the laws of the State of California. `,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `The`,
                }),
                new TextRun({
                    text: ` country of habitual residence`,
                    italics: true,
                }),
                new TextRun({
                    text: ` of the children in this case is the United States.`,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `  Child Support`,
                    italics: true,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `Child support shall be as agreed to and stated in the attached Child Support Information and Order Attachment, FL-342 and, if non-guideline, FL-342(a).`,

                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Child support shall continue until the child reaches the age of majority and graduates from high school, dies, marries or is otherwise emancipated, or until further order of Court, whichever occurs first. `,

                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Pursuant to FL-342, the parents have agreed as to which party shall maintain the children on their medical, dental, and vision insurance. The parent shall continue to do so long as it is remains reasonable.  The cost is presumed reasonable it if does not exceed 5% of the responsible parent’s gross income.  Each party shall keep the other informed as to when health insurance becomes available to him or her through his or her employer or other group health provider, and if so, the policy information.  The parties shall exchange health insurance cards for the children. `,

                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Any health expenses not paid by insurance shall be shared by each parent as agreed to in the FL-342, and outlined in the Notice of Rights and Responsibilities (FL-192) attached and incorporated into this Agreement. `,

                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "aside1",
        }),
    );
    console.log(regularScheduleValue, "rgggg")
    arrayFirst.push(

        new Paragraph({
            text: "MARITAL SETTLEMENT AGREEMENT",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.CENTER,
        }),

        new Paragraph({
            text: `This Marital Settlement Agreement (hereinafter Agreement) is made between self-represented parties, ${petitionerDetails.firstName} ${petitionerDetails.lastName} and ${respondentDetails.firstName} ${respondentDetails.lastName}, sometimes referred to jointly as the “Parties” or separately as the “Party,” or the “Parents” or separately as the “Parent.” `,
            style: "p1",
        }),

        new Paragraph({
            text: "This Agreement shall become part of the Judgment of Dissolution of Marriage. The effective date of this agreement (the “Effective Date”) is the date upon which it is signed by the last of the parties to do so. The parties shall timely execute any documents required to comply with this Agreement.",
            style: "p1",

        }),

        new Paragraph({
            text: "  Statistical Facts.",
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `${petitionerDetails.firstName} and ${respondentDetails.firstName} were married on ${moment(props.marriageDate).format('LL')}, and that the date of their separation was ${moment(props.seprationDate).format('LL')}. The self-represented parties completed and exchanged their Preliminary Declarations of Disclosure with one another; and negotiated all issues related to this matter to reach this Agreement.`,
                    spacing: {
                        line: 500,
                    },
                    bold: false
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },

            style: "aside1",
        }),
        // new Paragraph({
        //     text: `${petitionerDetails.firstName} and ${respondentDetails.firstName} were married on ${moment(props.marriageDate).format('LL')}, and that the date of their separation was ${moment(props.seprationDate).format('LL')}.`,
        //     numbering: {
        //         reference: "my-crazy-numbering",
        //         level: 1,
        //     },
        //     style: "aside1",
        //     bold:true
        // }), //tbd
        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: `The self-represented parties completed and exchanged their Preliminary Declarations of Disclosure with one another; and negotiated all issues related to this matter to reach this Agreement.`,

        //         }),
        //     ],
        //     numbering: {
        //         reference: "my-crazy-numbering",
        //         level: 8,
        //     },
        //     style: "aside1",
        // }), //tbd
        new Paragraph({
            children: [
                new TextRun({
                    text: `  Division of Property: `,
                    bold: true,
                    italics: true,
                }),
                new TextRun({
                    text: `The community, mixed and separate property of the parties shall be divided as follows and divided upon execution of this Agreement, if it has not already been divided: `,
                    bold: false,
                }),

            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "asidenew",

        }),

        new Paragraph({
            children: [
                new TextRun({
                    text: `Property Awarded or Confirmed to ${petitionerDetails.firstName}`,
                    underline: {},
                    bold: true,

                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "num",
        }),







        // new Paragraph({
        //     children: filteredArarydebtsPetitionerFinal,
        //     style: "aside1",
        // }),


        // new Paragraph({
        //     children: filteredAraryDebtsRespondentFinal.concat(filteredAraryassetRespondentFinal, filteredAraryAdditionalLanguageFinal),
        //     style: "aside1",
        // }),
        // new Paragraph({
        //     children: filteredAraryassetRespondentFinal,
        //     style: "aside1",
        // }),

        // new Paragraph({
        //     children: filteredAraryAdditionalLanguageFinal,
        //     style: "aside1",
        // }),

        new Paragraph({
            text: `  Equalization`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),
        new Paragraph({
            children: oweEqualizationPayment === "-1" ? [] : [
                new TextRun(
                    !(oweEqualizationPayment) ? {
                        text:
                            `No equalization payment is owed from either party to the other. The division of the community estate is fair, equal and agreed to by the parties.`
                    } : {
                        text: `${testinterestAccrue}`,
                    }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "asidenew",
        }),

        new Paragraph({
            text: `  Transfer of Retirement Assets`,
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),



        new Paragraph({
            text: `${transferRetirementValue}` === "0" ? `Transfer of Retirement Assets: Each party is awarded any and all retirement assets in his or her name. No rollover or transfers of retirement assets is required from either party to the other.` : "",
            style: "aside1",
            // numbering: {
            //     reference: "my-crazy-numbering",
            //     level: 2,
            // },
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `${transferRetirementValue}` === "1" ? `Any community or separate property interests in the parties’ retirement accounts is listed in Section 2. ` : "",

                }),
                new TextRun({
                    text: `${transferRetirementValue}` === "1" ? "Division of Property. " : "",
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "aside1",
        }),
        new Paragraph({
            text: `${transferRetirementValue}` === "1" ? `${test3}` : "",
            style: "aside1",
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
        }),
    )
    // insertToIndex
    //  arrayFirst= insertToIndex(arrayFirst, 7, firstArrayList)

    arrayFirst.splice(7, 0, ...firstArrayList);
    //arrayFirst =arrayFirst.splice(9, 0, ...RespondentList);
    arrayLast.push(new Paragraph({
        text: `  Wavier of spousal support:`,
        numbering: {
            reference: "my-crazy-numbering",
            level: 0,
        },
        style: "aside",
    }),

        regularScheduleValue.amount === 1 && new Paragraph({
            children: [
                new TextRun({
                    text: regularScheduleValue.amount === 1 ? `${custodyShall}` : 0,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 8,
            },
            style: "aside2",
        }),
        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: ` Spousal Support to Petitioner.`,
        //         }),
        //     ],
        //     numbering: {
        //         reference: "my-crazy-numbering",
        //         level: 4,
        //     },
        //     style: "aside1",
        // }),
        console.log(test6, "testttttt"),
        test6 === 0 && new Paragraph({
            text: `${test6}` === 0 ? `${respondentDetails.firstName} shall pay ${petitionerDetails.firstName} as permanent spousal support $${props.spousalRespondent.permanent} per month. Support shall begin on ${spousalRespondentDate}. Support payments shall be paid ½ on the 1st and ½ on the 15th of each month. ` : 0,

            style: "aside1",
        }),
        test6 === 0 && new Paragraph({
            text: `${test6}` === "0" ? `${test7}` : 0,

            style: "aside1",
        }),
        test6 === 0 && new Paragraph({
            text: `${test6}` === "0" ? `${petitionerDetails.firstName} ${petitionerDetails.lastName}  ________________________________` : 0,

            style: "aside1",
        }),
        test6 === 1 && new Paragraph({
            //  text: `${test6}` === "1" ? `Waiver of Support to ${petitionerDetails.firstName}. ${petitionerDetails.firstName} acknowledges that Petitioner may have been entitled to spousal support or other benefits from Respondent. After careful consideration of all the Family Code Section 4320 factors and other circumstances as well as other terms of this Agreement, Petitioner waives any rights or claims that Petitioner may have now or in the future to receive any spousal support from Respondent. This waiver is a binding, voluntary, mutual, permanent, termination of spousal support, and with full knowledge. Petitioner had an opportunity to consult with an attorney regarding this waiver. Petitioner agrees that the Court terminates its jurisdiction forevermore to award spousal support to Petitioner from Respondent, now or in the future, no matter the circumstances today or in the future or how compelling the need. Petitioner understands when the court terminates its jurisdiction, the Court no longer has the authority or power to award spousal support to ${petitionerDetails.firstName}. ` : 0,
            children: [
                new TextRun({
                    text: `Waiver of Support to ${petitionerDetails.firstName}.`,
                    underline: {},
                    bold: true,
                }),
                new TextRun({
                    text: ` ${petitionerDetails.firstName} acknowledges that Petitioner may have been entitled to spousal support or other benefits from Respondent. After careful consideration of all the Family Code Section 4320 factors and other circumstances as well as other terms of this Agreement, Petitioner waives any rights or claims that Petitioner may have now or in the future to receive any spousal support from Respondent. This waiver is a binding, voluntary, mutual, permanent, termination of spousal support, and with full knowledge. Petitioner had an opportunity to consult with an attorney regarding this waiver. Petitioner agrees that the Court terminates its jurisdiction forevermore to award spousal support to Petitioner from Respondent, now or in the future, no matter the circumstances today or in the future or how compelling the need. Petitioner understands when the court terminates its jurisdiction, the Court no longer has the authority or power to award spousal support to ${petitionerDetails.firstName}. `,
                    underline: false,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "asidenew",
        }),
        //
        test6 === 1 && new Paragraph({
            text: `${test6}` === "1" ? `${petitionerDetails.firstName} ${petitionerDetails.lastName}  ________________________________` : 0,

            style: "aside1",
        }),


        test6 === 2 && new Paragraph({
            text: `${test6}` === "2" ? `${test8}` : 0,

            style: "aside1",
        }),
        test6 === 2 && new Paragraph({
            text: `${test6}` === "2" ? `${petitionerDetails.firstName} ${petitionerDetails.lastName}  ________________________________` : 0,
            style: "aside1",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: ` Spousal Support to Respondent.`,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 4,
            },
            style: "aside1",
        }),
        test9 === 0 && new Paragraph({
            text: `${test9}` === "0" ? ` Petitioner shall pay Respondent as permanent spousal support $${props.spousalPetitioner.permanent} per month. Support shall begin on ${spousalPetitionerDate}. Support payments shall be paid ½ on the 1st and ½ on the 15th of each month. ` : "None",
            style: "aside1",
        }),

        test9 === 0 && new Paragraph({
            text: `${test9}` === "0" ? `${test10}` : 0,
            style: "aside1",
        }),
        test9 === 0 && new Paragraph({
            text: `${test9}` === "0" ? `${respondentDetails.firstName} ${respondentDetails.lastName}   ________________________________` : 0,
            style: "aside1",
        }),


        test9 === 1 && new Paragraph({
            children: [
                new TextRun({
                    text: `Waiver of Support to ${respondentDetails.firstName}.`,
                    underline: {},
                    bold: true,
                }),
                new TextRun({
                    text: ` ${respondentDetails.firstName} acknowledges that Respondent may have been entitled to spousal support or other benefits from Petitioner. After careful consideration of all the Family Code Section 4320 factors and other circumstances as well as other terms of this agreement, Respondent waives any rights or claims that Respondent may have now or in the future to receive any spousal support from Petitioner. This waiver is a binding, voluntary, mutual, permanent, termination of spousal support, and with full knowledge. Respondent had an opportunity to consult with an attorney regarding this waiver. Respondent agrees that the Court terminates its jurisdiction forevermore to award spousal support to Respondent from Petitioner, now or in the future, no matter the circumstances today or in the future or how compelling the need. Respondent understands when the court terminates its jurisdiction, the Court no longer has the authority or power to award spousal support to ${respondentDetails.firstName}. `,
                    underline: false,
                })
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 2,
            },
            style: "asidenew",
        }),
        test9 === 1 && new Paragraph({
            text: `${test9}` === "1" ? `${respondentDetails.firstName} ${respondentDetails.lastName}   ________________________________` : 0,

            style: "aside1",
        }),

        test9 === 2 && new Paragraph({
            text: `${test9}` === "2" ? `${test11}` : 0,

            style: "aside1",
        }),
        test9 === 2 && new Paragraph({
            text: `${test9}` === "2" ? `${respondentDetails.firstName} ${respondentDetails.lastName}  ________________________________` : 0,

            style: "aside1",
        }),
        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: `  Attorneys`,
        //             italics: true,
        //         }),
        //     ],
        //     numbering: {
        //         reference: "my-crazy-numbering",
        //         level: 0,
        //     },
        //     style: "aside",
        // }),
        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: `  The parties have had an opportunity to consult or receive advice from attorneys, accountants, and other advisors of their own selection with respect to all matters for their divorce as he or she deemed appropriate. `,
        //         }),
        //     ],
        //     style: "aside1",
        // }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `  Attorneys: `,
                    bold: true,
                    italics: true,
                }),
                new TextRun({
                    text: `The parties have had an opportunity to consult or receive advice from attorneys, accountants, and other advisors of their own selection with respect to all matters for their divorce as he or she deemed appropriate. `,
                    bold: false,
                }),

            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "asidenew",

        }),

        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: `Final Settlement.`,
        //             italics: true,
        //         }),
        //     ],
        //     numbering: {
        //         reference: "my-crazy-numbering",
        //         level: 0,
        //     },
        //     style: "aside",
        // }),
        // new Paragraph({
        //     children: [
        //         new TextRun({
        //             text: ` The parties represent and agree that this is a full and final settlement of all issues presented in this matter, including division of all assets and debts specifically included in disclosures and filed in this matter, whether accounted for in this Agreement or not.  The court shall retain jurisdiction to make rulings only on later-discovered assets and debts. `,
        //         }),
        //     ],
        //     style: "aside1",
        // }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Final Settlement: `,
                    bold: true,
                    italics: true,
                }),
                new TextRun({
                    text: `The parties represent and agree that this is a full and final settlement of all issues presented in this matter, including division of all assets and debts specifically included in disclosures and filed in this matter, whether accounted for in this Agreement or not.  The court shall retain jurisdiction to make rulings only on later-discovered assets and debts.`,
                    bold: false,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "asidenew",
        }),


        new Paragraph({
            children: [
                new TextRun({
                    text: `Final Distribution of Assets.`,
                    italics: true,
                }),
            ],
            numbering: {
                reference: "my-crazy-numbering",
                level: 0,
            },
            style: "aside",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: ` The parties, understanding that the distribution of assets and debts included herein may be unequal, hereby waive their right to an equal distribution. The parties waive all rights to any credits and reimbursements which may be owed to them pursuant to the divorce. `,
                }),
              
            ],
            style: "aside1",
        }),
        new Paragraph({
            children: [
              new TextRun({
                text: "///",
                size: 48, // Font size in half-points (e.g., 48 = 24pt)
                break:1
              }),

              new TextRun({
                text: "///",
                size: 48, // Font size in half-points (e.g., 48 = 24pt)
                break:1
              }),
              new TextRun({
                text: "///",
                size: 48, // Font size in half-points (e.g., 48 = 24pt)
                break:1
              }),
              new TextRun({
                text: "///",
                size: 48, // Font size in half-points (e.g., 48 = 24pt)
                break:1
              }),
              new TextRun({
                text: "///",
                size: 48, // Font size in half-points (e.g., 48 = 24pt)
                break:1
              }),

            ],
          }),
        new Paragraph({
            children: [new TextRun(""), new PageBreak()],
        }),



        new Paragraph({
            children: [
                new TextRun({
                    text: ` The parties are responsible for knowing and understanding the terms of the Agreement.  If you have a question, or are uncertain about the terms of this Agreement, legal assistance or research should be conducted prior to signing. `,
                }),
            ],
            style: "aside6",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `THE FOREGOING AGREEMENT CONSTITUTES THE WRITTEN SETTLEMENT AGREEMENT OF THE PARTIES AND IS INTENDED TO BE BINDING AND ENFORCEABLE PURSUANT TO THE PROVISIONS OF SECTION 664.6 OF THE CALIFORNIA CODE OF CIVIL PROCEDURE:`,
                    break: 1,
                    font: {
                        name: "Monospace",
                    },
                }),
            ],
            style: "aside4",
        }),
        new Paragraph({

        }),
        new Paragraph({
            text: "Dated: ",
            style: "wellSpaced",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `_______________________________`,
                }),

            ],
            style: "aside1",
        }),
        new Paragraph({
            children: [

                new TextRun({
                    text: `${petitionerDetails.firstName} ${petitionerDetails.lastName}`,
                }),
            ],
            style: "aside1",
        }),
        new Paragraph({
            text: "Dated: ",
            style: "wellSpaced",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `_______________________________`,
                }),

            ],
            style: "aside1",
        }),
        new Paragraph({
            children: [

                new TextRun({
                    text: `${respondentDetails.firstName} ${respondentDetails.lastName}`,
                }),
            ],
            style: "aside1",
        }),

        new Paragraph({
            children: [

                new TextRun({
                    text: `IT IS SO ORDERED:`,
                    bold: true,
                }),
            ],
            style: "aside5",
        }),
        new Paragraph({
            children: [
                new TextRun({
                    text: `Dated: `,
                }),
                new TextRun({
                    text: `\t \t \t \t \t _______________________________`,
                }),

            ],
            style: "wellSpaced",
        }),
        new Paragraph({
            children: [

                new TextRun({
                    text: `\t \t \t \t \t \t \t JUDGE OF THE SUPERIOR COURT`,
                }),
            ],
            style: "wellSpaced",
        }))

        
    const generate = () => {
        setFinalShow(true);
        const doc = new Document({
            creator: "Clippy",
            title: "MSample Document",
            description: "A brief example of using docx",
            styles: {
                default: {
                    heading1: {
                        run: {
                            size: 28,
                            bold: true,
                            color: "black",
                            font: "Arial",
                            spacing: {
                                after: 120,
                            },
                        },
                        paragraph: {
                            spacing: {
                                line: 476, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05
                            },
                        },
                    },
                    listParagraph: {
                        run: {
                            color: "#FF0000",
                        },
                    },
                },
                paragraphStyles: [
                    {
                        id: "asidenew",
                        name: "Aside",
                        basedOn: "Normal",
                        next: "Normal",
                        bold: true,
                        run: {
                            size: 22,
                            color: "black",

                            font: "Arial",

                            hidden: true,
                        },

                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 500,
                            },
                        },
                    },
                    {
                        id: "aside",
                        name: "Aside",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            italics: true,
                            font: "Arial",
                            bold: true,
                            hidden: true,
                        },

                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 500,
                            },
                        },
                    },

                    {
                        id: "aside1",
                        name: "Aside1",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 500,
                            },
                        },
                    },

                    {
                        id: "aside6",
                        name: "Aside6",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            bold: true,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 500,
                            },
                        },
                    },

                    {
                        id: "aside2",
                        name: "Aside2",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 500,
                            },
                        },
                    },
                    {
                        id: "num",
                        name: "Num",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",
                        },
                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 200,
                            },
                        },
                    },
                    {
                        id: "numSpace",
                        name: "Num",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",
                        },
                        paragraph: {
                            indent: {
                                left: 500,
                            },
                            spacing: {
                                line: 500,
                                hanging: 260
                            },
                        },
                    },
                    {
                        id: "tableStyle",
                        name: "Num",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",
                        },
                        paragraph: {
                            indent: {
                                left: 100,
                            },
                            spacing: {
                                line: 200,
                                hanging: 260
                            },
                        },
                    },
                    {
                        id: "num1",
                        name: "Num1",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",
                        },
                        paragraph: {
                            indent: { left: 280, hanging: 260 },
                            spacing: {
                                line: 450,
                            },
                        },
                    },

                    {
                        id: "aside3",
                        name: "Aside3",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            spacing: {
                                line: 850, /*before: 20 * 72 * 0.1, after: 20 * 72 * 0.058*/
                            },
                        },
                    },

                    {
                        id: "p1",
                        name: "P1",
                        basedOn: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            spacing: {
                                line: 500, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05
                            },
                        },
                    },

                    {
                        id: "aside4",
                        name: "Aside4",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 28,
                            color: "black",
                        },


                    },
                    {
                        id: "aside5",
                        name: "Aside5",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            indent: {
                                left: convertInchesToTwip(0.5),
                            },
                            spacing: {
                                line: 800,
                            },
                        },
                    },
                    {
                        id: "aside6",
                        name: "Aside6",
                        basedOn: "Normal",
                        next: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            indent: {
                                left: 100, hanging: 120
                            },
                        },
                    },

                    {
                        id: "header",
                        name: "Header",
                        basedOn: "Normal",
                        run: {
                            size: 22,
                            color: "black",
                            font: "Arial",

                        },
                        paragraph: {
                            spacing: {
                                line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05
                            },
                            indent: { left: 8000, hanging: 260 },
                        },
                    },
                    {
                        id: "wellSpaced",
                        name: "Well Spaced",
                        basedOn: "Normal",
                        quickFormat: true,
                        run: {
                            size: 28,
                            color: "black",
                            font: "Monospace",

                        },
                        paragraph: {
                            spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                            indent: { left: 280, hanging: 260 },

                        },
                    },
                ],
            },
            numbering: {
                config: [
                    {
                        reference: "my-crazy-numbering",
                        levels: [
                            {
                                level: 0,
                                format: upperRoman,
                                text: "%1 )",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 220, hanging: 260, },
                                    },
                                },
                            },
                            {
                                level: 1,
                                format: LevelFormat.LOWER_LETTER,
                                text: "%2. ",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 180, hanging: 260 },

                                    },
                                    run: {
                                        bold: true,
                                    }
                                },
                            },
                            {
                                level: 2,
                                format: LevelFormat.LOWER_LETTER,
                                text: "%3.   ",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 580, hanging: 260 },

                                    },
                                    run: {
                                        bold: true,
                                    }
                                },
                            },
                            {
                                level: 3,
                                format: upperRoman,
                                text: "%4)",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 520, hanging: 260, },
                                    },
                                },
                            },
                            {
                                level: 4,
                                format: LevelFormat.LOWER_LETTER,
                                text: "%5. ",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 580, hanging: 260, },
                                    },
                                    run: {
                                        bold: true,
                                    }
                                },
                            },
                            {
                                level: 5,
                                format: upperRoman,
                                text: "%6)",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 1020, hanging: 260, },
                                    },
                                },
                            },
                            {
                                level: 6,
                                format: upperRoman,
                                text: "%7)",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 1020, hanging: 260, },
                                    },
                                },
                            },
                            {
                                level: 7,
                                format: upperRoman,
                                text: "%8)",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 1020, hanging: 260, },
                                    },
                                },
                            },
                            {
                                level: 8,
                                format: LevelFormat.BULLET,
                                text: "%9.",
                                alignment: AlignmentType.START,
                                style: {
                                    paragraph: {
                                        indent: { left: 1280, hanging: 260 },
                                    },
                                },
                            },


                        ],

                    },
                ],
            },
            sections: [{
                footers: {
                    default: new Footer({
                        children: [
                            new Paragraph({
                                children: [
                                    //new TextRun("Initial ___________P   ___________R "),
                                    new TextRun(`${petitionerDetails.firstName}  ${respondentDetails.lastName}`),
                                    new TextRun(`\t MARITAL SETTLEMENT AGREEMENT`),
                                    new TextRun(`\t \t Case No: ${courtDetails.caseNumber}`),
                                    new TextRun({
                                        children: ["\t \t \t \t  \t \t Page ", PageNumber.CURRENT],
                                        break: 1,
                                        indent: {
                                            left: 5000,
                                        },
                                    }),

                                ],

                            }),
                        ],
                    }),
                },
                children: `${minorChildren}` === "0" ? arrayFirst.concat(arrayLast) : arrayFirst.concat(arrayMid).concat(arrayLast)
            },
            ],
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, "MSA.docx");
        });
    }





    function getSteps() {
        return [
            'DIVISION OF PROPERTY',
            'DIVISION OF DEBTS',
            'EQUALIZATION PAYMENT',
            'TRANSFER OF RETIREMENT ASSETS',
            'PARENTING PLAN',
            'Regular Schedule',
            'Holiday Schedule',
            'Summer Schedule/Summer Vacation',
            'CHILD SUPPORT',
            'SPOUSAL SUPPORT',
        ];
    }


    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        {/* Q1 Started */}
                        <FormGroup>
                            <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>DIVISION OF PROPERTY</h3>
                            <label>First, let’s select some general options to include in your agreement please select which general provisions to apply for Petitioner and Respondent
                            </label>
                            <p>
                                <b> Petitioner shall receive</b>
                            </p>

                        </FormGroup>
                        <div style={{ paddingLeft: "20px" }} >

                            <FormGroup>
                                <Input
                                    style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="1"
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '1'))}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> All checking, savings, money market, and all other financial accounts in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="2"
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '2'))}
                                >

                                </Input>
                                <label style={{ padding: "2px 15px" }}> Any and all retirement accounts in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="3"
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '3'))}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="4"
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '4'))}>
                                </Input>
                                <label style={{ padding: "2px 15px" }}>All clothing, jewelry, and personal effects in Petitioner’s possession.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="5"
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '5'))}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Any credit card points, reward credits, and airline miles in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="6"
                                    defaultChecked={!isEmpty(props.generalProvisionsPetitioner.val) && size(props.generalProvisionsPetitioner.val.find(x => x === '6'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Minimal cash in Petitioner’s possession.</label>
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <p>
                                <b> Respondent shall receive</b>
                            </p>

                        </FormGroup>
                        <div style={{ paddingLeft: "20px" }} >
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="7"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '7'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> All checking, savings, money market, and all other financial accounts in Respondent’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="8"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '8'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Any and all retirement accounts in Respondent’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="9"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '9'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="10"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '10'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>All clothing, jewelry, and personal effects in Respondent’s possession</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="11"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '11'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Any credit card points, reward credits, and airline miles in Respondent’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="12"
                                    defaultChecked={!isEmpty(props.generalProvisionsRespondent.val) && size(props.generalProvisionsRespondent.val.find(x => x === '12'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> Minimal cash in Respondent’s possession.</label>
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <p>
                                <b> Now, let’s put in specific assets.</b>
                            </p>
                            <label>Use your disclosure documents as a checklist so you remember all assets. Also, include the last four numbers of your accounts and VIN for vehicles. </label>
                            <Alert style={{
                                backgroundColor: "#f0fbfb",
                                color: "black",
                                textAlign: "justify"
                                , textJustify: "auto"
                            }} icon={false} severity="warning"><b>Hint:</b> You can include an instruction like, “2017 Honda Accord Vin #XXX2134. Petitioner shall transfer title to his name no later than 45 days from signing the Agreement, and the Respondent shall cooperate to remove her name from title.”
                                <br />
                                <br />
                                “The 2014 Chevy Tahoe, VIN #XXX1234, in Respondent’s name, with an approximate value of $18,500.00, and a loan for approximately $12,300.00 in Respondent’s name.  Respondent shall be responsible for the loan.
                            </Alert>
                            <br />
                            <p>
                                <b>Write what other assets Petitioner will receive and any instructions for those assets. </b>
                            </p>
                            {!isEmpty(inputFields) && inputFields.map((inputField, index) => (
                                <div key={index} >
                                    <Row>
                                        <Col lg={12} style={{ padding: "5px 30px" }}>
                                            <Input
                                                type="textarea"
                                                id="first"
                                                defaultValue={inputField.first}
                                                onBlur={(e) => { handleChangeInput(index, e) }}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Row>
                                <Col lg={12}>
                                    <IconButton onClick={() => handleRemoveFields()} style={{ float: "right", color: "black", marginTop: "15px" }}  >
                                        <RemoveIcon />
                                    </IconButton>

                                    <IconButton onClick={() => handleAddFields()} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                        <AddIcon />
                                    </IconButton>
                                </Col>
                            </Row>
                            {/* <ColoredLine /> */}




                            <br />
                            <p>
                                <b>Write what other assets the Respondent will receive and any instructions for those assets.  </b>
                            </p>
                            {!isEmpty(inputFieldsSecond) && inputFieldsSecond.map((inputFieldsSecond, index) => (
                                <div key={index} >
                                    <Row>
                                        <Col lg={12} style={{ padding: "5px 30px" }}>
                                            <Input
                                                type="textarea"
                                                id="second"
                                                defaultValue={inputFieldsSecond.second}
                                                onBlur={(e) => { handleChangeInput1(index, e) }}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Row>
                                <Col lg={12}>
                                    <IconButton onClick={() => handleRemoveFields1()} style={{ float: "right", color: "black", marginTop: "15px" }}  >
                                        <RemoveIcon />
                                    </IconButton>

                                    <IconButton onClick={() => handleAddFields1()} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                        <AddIcon />
                                    </IconButton>
                                </Col>
                            </Row>



                        </FormGroup>
                    </div>

                );

            case 1:
                return (
                    <div>
                        {/* Q2 Started */}
                        <FormGroup>
                            <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>DIVISION OF DEBTS</h3>
                            <p>
                                <b> First, let’s select some general options to include in your agreement please select which general provisions to apply for Petitioner</b>
                            </p>

                        </FormGroup>
                        <div style={{ paddingLeft: "20px" }} >
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="13"
                                    defaultChecked={!isEmpty(props.provisionsPetitioner.val) && size(props.provisionsPetitioner.val.find(x => x === '13'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}
                                > Petitioner shall be responsible for any and all obligations (debts) in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="14"
                                    defaultChecked={!isEmpty(props.provisionsPetitioner.val) && size(props.provisionsPetitioner.val.find(x => x === '14'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>  Petitioner shall be responsible for any and all credit card debts in Petitioner’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="15"
                                    defaultChecked={!isEmpty(props.provisionsPetitioner.val) && size(props.provisionsPetitioner.val.find(x => x === '15'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Petitioner shall be responsible for any and all school loans in Petitioner’s name..</label>
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <p>
                                <b>First, let’s select some general options to include in your agreement  please select which general provisions to apply for Respondent</b>
                            </p>

                        </FormGroup>
                        <div style={{ paddingLeft: "20px" }} >
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="16"
                                    defaultChecked={!isEmpty(props.provisionsRespondent.val) && size(props.provisionsRespondent.val.find(x => x === '16'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> Respondent shall be responsible for any and all obligations (debts) in Respondent’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="17"
                                    defaultChecked={!isEmpty(props.provisionsRespondent.val) && size(props.provisionsRespondent.val.find(x => x === '17'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> Respondent shall be responsible for any and all credit card debts in Respondent’s name.</label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="18"
                                    defaultChecked={!isEmpty(props.provisionsRespondent.val) && size(props.provisionsRespondent.val.find(x => x === '18'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Respondent shall be responsible for any and all school loans in Respondent’s name.</label>
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <p>
                                <b> Please write in what other debts Petitioner will be responsible to pay.</b>
                            </p>
                            <Alert style={{
                                backgroundColor: "#f0fbfb",
                                color: "black"
                            }} icon={false} severity="warning"><b> Hint:</b> See the Sample MSA for suggested language.
                            </Alert>
                            <br />


                            {!isEmpty(inputFieldsThird) && inputFieldsThird.map((inputFieldsThird, index) => (
                                <div key={index} >
                                    <Row>
                                        <Col lg={12} style={{ padding: "5px 30px" }}>
                                            <Input
                                                type="textarea"
                                                id="third"
                                                defaultValue={inputFieldsThird.third}
                                                onBlur={(e) => { handleChangeInput2(index, e) }}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Row>
                                <Col lg={12}>
                                    <IconButton onClick={() => handleRemoveFields2()} style={{ float: "right", color: "black", marginTop: "15px" }}  >
                                        <RemoveIcon />
                                    </IconButton>

                                    <IconButton onClick={() => handleAddFields2()} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                        <AddIcon />
                                    </IconButton>
                                </Col>
                            </Row>




                            <br />
                            <p>
                                <b>Please write in what other debts Respondent will be responsible to pay.  </b>
                            </p>
                            <Alert style={{
                                backgroundColor: "#f0fbfb",
                                color: "black"
                            }} icon={false} severity="warning"><b> Hint:</b> See the Sample MSA for suggested language.
                            </Alert>
                            <br />


                            {!isEmpty(inputFieldsForth) && inputFieldsForth.map((inputFieldsForth, index) => (
                                <div key={index} >
                                    <Row>
                                        <Col lg={12} style={{ padding: "5px 30px" }}>
                                            <Input
                                                type="textarea"
                                                id="forth"
                                                defaultValue={inputFieldsForth.forth}
                                                onBlur={(e) => { handleChangeInput3(index, e) }}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Row>
                                <Col lg={12}>
                                    <IconButton onClick={() => handleRemoveFields3()} style={{ float: "right", color: "black", marginTop: "15px" }}  >
                                        <RemoveIcon />
                                    </IconButton>

                                    <IconButton onClick={() => handleAddFields3()} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                        <AddIcon />
                                    </IconButton>
                                </Col>
                            </Row>

                        </FormGroup>
                        <FormGroup>
                            <p>
                                <b> Select additional language you want to include in the Debts section</b>
                            </p>

                        </FormGroup>
                        <div style={{ paddingLeft: "20px" }} >
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="19"
                                    defaultChecked={!isEmpty(props.addtionLanguage.val) && size(props.addtionLanguage.val.find(x => x === '19'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}> The parties shall cooperate in canceling all joint credit cards and store accounts. </label>
                            </FormGroup>
                            <FormGroup>
                                <Input style={{ width: "16px", height: "16px" }}
                                    type="checkbox"
                                    id="20"
                                    defaultChecked={!isEmpty(props.addtionLanguage.val) && size(props.addtionLanguage.val.find(x => x === '20'))}
                                    onChange={(e) => getCheckedValue(e.target.id)}
                                >
                                </Input>
                                <label style={{ padding: "2px 15px" }}>Neither party shall make any further charges on any credit card or store account for which the other party is or may be liable.</label>
                            </FormGroup>

                        </div>
                    </div>

                );
            case 2:
                return (
                    <div>
                        {/* Q3 Started */}
                        <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>EQUALIZATION PAYMENT</h3>
                        <div style={{ paddingBottom: "10px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <b style={{ paddingRight: "7px" }}></b> Will either of you owe the other an equalization payment?
                                </Label>
                                <Input
                                    defaultValue={props.oweEqualizationPayment.val}
                                    type="select"
                                    name="married"
                                    id="equalization"
                                    onChange={(e) => setMaritalSixteen(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.oweEqualizationPayment.val === "0"}>No</option>
                                    <option value="1" selected={props.oweEqualizationPayment.val === "1"}>Yes</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalSixteen === 1 ? true : false}>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <b style={{ paddingRight: "7px" }}></b> Select who owes the payment to the other
                                    </Label>
                                    <Input
                                        defaultValue={props.owesPayment.val}
                                        type="select"
                                        id="owespayment"
                                        onChange={(e) => setMaritalOne(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.owesPayment.val === "0"}>Petitioner owes Respondent</option>
                                        <option value="1" selected={props.owesPayment.val === "1"}> Respondent owes Petitioner</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <b style={{ paddingRight: "7px" }}></b> How much does the spouse owe?
                                    </Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>$</InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            defaultValue={
                                                Number(props.spouseOwe.val)
                                            }
                                            type="number"
                                            id="spouseowes"
                                        >
                                        </Input>
                                    </InputGroup>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <b style={{ paddingRight: "7px" }}></b>Is the payment due all at once?
                                    </Label>
                                    <Input
                                        defaultValue={props.paymentDue.amount}

                                        type="select"
                                        id="paydate"
                                        onChange={(e) => setMaritalFifteen(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.paymentDue.amount === "0"} >No</option>
                                        <option value="1" selected={props.paymentDue.amount === "1"}>Yes</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <Collapse isOpen={isMaritalFifteen === 1 ? true : false}>
                                    <FormGroup>
                                        <Label for="exampleSelect">
                                            When is the payment due?
                                        </Label>
                                        <Input
                                            defaultValue={props.paymentDue.date === '1947-01-01' ? moment(Date.now()).format('YYYY-MM-DD') : moment(props.paymentDue.date).format('YYYY-MM-DD')}

                                            type="date"
                                            id="payduedate"
                                        >
                                        </Input>
                                    </FormGroup>
                                </Collapse>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <Collapse isOpen={isMaritalFifteen === 0 ? true : false}>
                                    <FormGroup>
                                        <Label for="exampleSelect">
                                            What is the payment plan? Please write it clearly. How you write it here is how it will appear in your MSA.
                                        </Label>
                                        <Input
                                            defaultValue={props.paymentDue.val}
                                            type="textarea"
                                            name="married"
                                            id="payplan"
                                        >
                                        </Input>
                                    </FormGroup>
                                </Collapse>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">
                                        <b style={{ paddingRight: "7px" }}> </b>  Will any interest accrue if the payment is not  made on time?
                                    </Label>
                                    <Input
                                        defaultValue={props.interestAccrue.amount}
                                        type="select"
                                        name="married"
                                        id="interest"
                                        onChange={(e) => setMaritalTwo(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.interestAccrue.amount === "0"}>No</option>
                                        <option value="1" selected={props.interestAccrue.amount === "1"}>Yes</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px" }}>
                                <Collapse isOpen={isMaritalTwo === 1 ? true : false}>
                                    <FormGroup>
                                        <Label for="exampleSelect">
                                            How much interest will accrue per annum
                                        </Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>%</InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                defaultValue={
                                                    Number(props.interestAccrue.val)
                                                }
                                                type="number"
                                                id="perannum"
                                            >
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Collapse>
                            </div>
                        </Collapse>
                    </div>

                );

            case 3:
                return (
                    <div>
                        {/* Q3 Started */}
                        <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>TRANSFER OF RETIREMENT ASSETS</h3>
                        <div style={{ paddingBottom: "10px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <b style={{ paddingRight: "7px" }}></b> Will either of you need to divide any retirements, transferring a portion of the retirement from one of you to the other party?
                                </Label>
                                <Input
                                    defaultValue={props.transferRetirementValue.amount}
                                    type="select"
                                    name="married"
                                    id="portionretirement"
                                    onChange={(e) => setMaritalSeventeen(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.transferRetirementValue.amount === "0"} >No</option>
                                    <option value="1" selected={props.transferRetirementValue.amount === "1"}>Yes</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalSeventeen === 1 ? true : false}>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <Label style={{ marginBottom: "20px" }}>
                                        <b style={{ paddingRight: "7px" }}></b> Will any of these transfers require a QDRO?
                                    </Label>
                                    <Alert style={{
                                        backgroundColor: "#f0fbfb",
                                        color: "black",
                                        textAlign: "justify",
                                        textJustify: "auto"
                                    }} icon={false} severity="warning"><b>Hint : </b>Please review the Division of Assets & Debts video tutorial. Any 401(k), 403(b), 457(b) or similar kind of retirement requires a QDRO. IRAs do not. </Alert>
                                    <Input style={{ margin: "20px 0" }}
                                        defaultValue={props.requireQdro.amount}
                                        type="select"
                                        name="married"
                                        id="divisionassets"
                                        onChange={(e) => setMaritalTen(JSON.parse(e.target.value))}
                                    >
                                        <option disabled selected value>
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.requireQdro.amount === "0"} >No</option>
                                        <option value="1" selected={props.requireQdro.amount === "1"}> Yes</option>
                                    </Input>
                                </FormGroup>
                            </div>
                        </Collapse>
                    </div>

                );
            case 4:
                return (
                    <div>
                        {/* Q3 Started */}
                        <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>PARENTING PLAN</h3>

                        <FormGroup>
                            <Label for="exampleSelect">
                                Do you have minor children?
                            </Label>
                            <Input
                                defaultValue={props.minorChildren.amount}
                                type="select"
                                name="married"
                                id="minorchildren"
                                onChange={(e) => setMaritalThree(JSON.parse(e.target.value))}
                            >
                                <option disabled value>
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value="0" selected={props.minorChildren.amount === "0"} >No</option>
                                <option value="1" selected={props.minorChildren.amount === "1"}>Yes</option>
                            </Input>
                        </FormGroup>
                        <div style={{ paddingBottom: "10px" }}>
                            <Collapse isOpen={isMaritalThree === 1 ? true : false}>
                                <FormGroup>
                                    <Label for="exampleSelect">

                                    </Label>

                                    <Row>
                                        <Col lg="4">
                                            <label><b>Child’s Name</b></label>
                                        </Col>
                                        <Col lg="4">
                                            <label><b>Legal Custody (Name of Parent(s) or Joint)</b></label>
                                        </Col>
                                        <Col lg="4">
                                            <label><b>Physical Custody (Name of Parent(s) or Joint)</b></label>
                                        </Col>
                                    </Row>
                                    {!isEmpty(inputFieldsFive) && inputFieldsFive.map((inputFieldsFive1, index) => (
                                        <div key={index} >


                                            <Row>

                                                <Col lg="4">

                                                    <Input style={{ margin: "10px 0" }}

                                                        defaultValue={isUndefined(props.childData) ? '' : inputFieldsFive1.childName}
                                                        type="text"
                                                        name="married"
                                                        id="childName"
                                                        onBlur={(e) => { handleChangeInput4(index, e) }}
                                                    >

                                                    </Input>

                                                </Col>
                                                <Col lg="4">

                                                    <Input style={{ margin: "10px 0" }}
                                                        defaultValue={isUndefined(props.childData) ? '' : inputFieldsFive1.legalCustody}
                                                        type="text"
                                                        name="married"
                                                        id="legalCustody"
                                                        onBlur={(e) => { handleChangeInput4(index, e) }}
                                                    >

                                                    </Input>

                                                </Col>

                                                <Col lg="4">

                                                    <Input style={{ margin: "10px 0" }}
                                                        defaultValue={isUndefined(props.childData) ? '' : inputFieldsFive1.soleCustody}
                                                        type="text"
                                                        name="married"
                                                        id="soleCustody"
                                                        onBlur={(e) => { handleChangeInput4(index, e) }}
                                                    >

                                                    </Input>

                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                    <Row>
                                        <Col lg={12}>
                                            <IconButton onClick={() => handleRemoveFields4()} style={{ float: "right", color: "black", marginTop: "15px" }}  >
                                                <RemoveIcon />
                                            </IconButton>

                                            <IconButton onClick={() => handleAddFields4()} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                                <AddIcon />
                                            </IconButton>
                                        </Col>
                                    </Row>

                                </FormGroup>
                            </Collapse>
                        </div>
                    </div>
                );
            case 5:
                return (
                    <div>
                        {/* Q3 Started */}
                        <FormGroup>
                            <Label for="exampleSelect">
                                <b> Let’s work on the timeshare schedules. I’ll ask you for the Regular Schedule</b>
                            </Label>
                        </FormGroup>
                        <div style={{ paddingBottom: "10px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    Which schedule do you have?
                                </Label>
                                <Input
                                    defaultValue={props.regularScheduleValue.amount}
                                    type="select"
                                    name="married"
                                    id="regular"
                                    onChange={(e) => setMaritalFive(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.regularScheduleValue.amount === "0"}>Week On/Week Off</option>
                                    <option value="1" selected={props.regularScheduleValue.amount === "1"}>Parent 2 reads Respondent and Parent 1 reads Petitioner</option>
                                    <option value="2" selected={props.regularScheduleValue.amount === "2"}>2-2-5-5 Schedule</option>
                                    <option value="3" selected={props.regularScheduleValue.amount === "3"}>  Other</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalFive === 0 ? true : false}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    The parties shall alternate physical custody of the children on a week on and week off basis. The date must be after the Petition was filed. The parties shall exchange the children on
                                </Label>
                                <Row>
                                    <Col md="4">
                                        <label> <b>Start Date</b></label>
                                        <Input
                                            defaultValue={props.regularScheduleValue.date === '' ? moment(Date.now()).format('YYYY-MM-DD') : moment(props.regularScheduleValue.date).format('YYYY-MM-DD')}
                                            type="date"
                                            name="married"
                                            id="weekdate"
                                        >
                                        </Input>
                                    </Col>
                                    <Col md="4">
                                        <label> <b>Time</b></label>
                                        <Input
                                            defaultValue={props.regularScheduleValue.time === '' ? moment(Date.now()).format('hh:mm:ss') : props.regularScheduleValue.time}
                                            type="time"
                                            name="married"
                                            id="weektime"
                                        >
                                        </Input>
                                    </Col>
                                    <Col md="4">
                                        <label><b> Place</b></label>
                                        <Input
                                            defaultValue={props.regularScheduleValue.val}
                                            type="text"
                                            name="married"
                                            id="weekplace"
                                        >
                                        </Input>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">


                                        <FormControl className={classes.formControl}>
                                            <InputLabel id="demo-mutiple-chip-label">Select Exchange Day</InputLabel>
                                            <Select
                                                labelId="demo-mutiple-chip-label"
                                                id="demo-mutiple-chip"
                                                multiple
                                                value={personName}
                                                onChange={handleChangeChip}
                                                input={<MInput
                                                    defaultValue={isUndefined(props.regularScheduleValue.day) || isEmpty(props.regularScheduleValue.day) ? [] : props.regularScheduleValue.day}
                                                    id="select-multiple-chip"

                                                />}
                                                renderValue={(selected) => (
                                                    <div className={classes.chips}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} className={classes.chip} />
                                                        ))}
                                                    </div>
                                                )}
                                                MenuProps={MenuProps}
                                            >
                                                {names.map((name) => (
                                                    <MenuItem key={name} value={name} selected style={getStyles(name, personName, theme)}>
                                                        {name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Collapse>
                        <Collapse isOpen={isMaritalFive === 1 ? true : false}>
                            <div>
                                <div style={{ paddingBottom: "10px" }}>
                                    <FormGroup>
                                        <label>
                                            <b>What date will you start this custody arrangement? The date must be after the Petition was filed. </b>
                                        </label>

                                        <Input
                                            defaultValue={props.scheduleDate.date === '' ? moment(Date.now()).format('YYYY-MM-DD') : moment(props.scheduleDate.date).format('YYYY-MM-DD')}
                                            min={'2021-02-02'}
                                            type="date"
                                            name="married"
                                            id="scheduledate"

                                        >
                                        </Input>

                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input style={{ height: "100px" }}
                                            defaultValue={isEmpty(props.weekPetitionalShall.val) ? "Week One: Petitioner shall have physical custody of the children every Monday from the start of school or 8:30 a.m. through Wednesday morning return to school or at 8:30 a.m. Parent 2 shall have physical custody of the children every Wednesday from the start of school or 8:30 a.m. through Friday morning return to school or at 8:30 a.m" : props.weekPetitionalShall.val}
                                            type="textarea"
                                            id="weekpetitional"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>

                                        <Input style={{ height: "100px" }}
                                            defaultValue={isEmpty(props.weekRespondentShall.val) ? "Week Two: Respondent shall have physical custody of the children every Monday from the start of school or 8:30 a.m. through Wednesday morning return to school or at 8:30 a.m.  Parent 1 shall have physical custody of the children every Wednesday from the start of school or 8:30 a.m. through Friday morning return to school or at 8:30 a.m" : props.weekRespondentShall.val}
                                            type="textarea"
                                            id="weekrespondent"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>

                                        <Input
                                            defaultValue={isEmpty(props.alternateMonday.val) ? "The parties shall continue to alternate Monday/Tuesday and Wednesday/Thursday" : props.alternateMonday.val}
                                            type="textarea"
                                            id="alternatemonday"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>

                                        <Input style={{ height: "100px" }}
                                            defaultValue={isEmpty(props.alternateWeekend.val) ? "The parties shall alternate weekends so that the parent who did not have physical custody of the children on the preceding Thursday (day before), shall have physical custody of the children from Friday morning at the start of school or 8:30 a.m., until Monday morning at the start of school or 8:30 a.m" : props.alternateWeekend.val}
                                            type="textarea"
                                            id="alternateweekend"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>

                                        <Input
                                            defaultValue={isEmpty(props.remainFlexible.val) ? "The parties shall remain flexible with one another to make adjustments to the schedule as needed, and in their children’s best interests" : props.remainFlexible.val}
                                            type="textarea"
                                            id="remainflexible"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                            </div>

                        </Collapse>
                        <Collapse isOpen={isMaritalFive === 2 ? true : false}>
                            <div style={{ paddingBottom: "10px" }}>
                                <FormGroup>
                                    <label>
                                        <b>What date will you start this custody arrangement? </b>
                                    </label>

                                    <Input
                                        defaultValue={props.commencingDate.date === '' ? moment(Date.now()).format('YYYY-MM-DD') : moment(props.commencingDate.date).format('YYYY-MM-DD')}
                                        min={'2021-02-02'}
                                        type="date"
                                        name="married"
                                        id="commencingdate"
                                    >
                                    </Input>

                                </FormGroup>
                            </div>
                            <div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input
                                            type="textarea"
                                            defaultValue={isEmpty(props.petitionalShall.val) ? "Petitioner shall have the right to physical custody every Monday from start of school or 8:30 a.m. when school is not in session to Wednesday drop off to school or 8:30 a.m. when school is not in session" : props.petitionalShall.val}
                                            id="petitionalshall"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input
                                            defaultValue={isEmpty(props.respondentShall.val) ? "Respondent Shall have the right to physical custody every Wednesday from start of school or 8:30 a.m. when school is not in session to Friday drop off at school or 8:30 a.m. when school is not in session" : props.respondentShall.val}
                                            type="textarea"
                                            id="respondentshall"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input
                                            defaultValue={isEmpty(props.partiesShall.val) ? "The parties shall alternate weekends with one parent having the children from Friday start of school or 8:30 a.m. when school is not in session to Monday morning return to school or 8:30 a.m. when school is not in session" : props.partiesShall.val}
                                            type="textarea"
                                            id="partiesshall"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input
                                            defaultValue={isEmpty(props.custodyShall.val) ? "The custodial parent shall be responsible for returning the child either to school when school is in session or to the residence of the non-custodial parent (receiving parent), when school is not in session" : props.custodyShall.val}
                                            type="textarea"
                                            id="custodyshall"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <Input
                                            defaultValue={isEmpty(props.parentShall.val) ? "The parents shall remain flexible with one another to make adjustments to the schedule as needed, and in their children’s best interests" : props.parentShall.val}
                                            type="textarea"
                                            id="parentshall"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                            </div>

                        </Collapse>

                        <Collapse isOpen={isMaritalFive === 3 ? true : false}>
                            <FormGroup>
                                <label>
                                    Please write in your Regular Schedule. See the Sample MSA for sample language
                                </label>

                                <Input
                                    defaultValue={props.regularOther.val}
                                    type="textarea"
                                    name="married"
                                    id="regularother"
                                >
                                </Input>

                            </FormGroup>

                        </Collapse>

                    </div>

                );

            case 6:
                return (
                    <div>
                        {/* Q3 Started */}
                        <FormGroup>
                            <Label for="exampleSelect">
                                <b> Let’s work on the timeshare schedules. I’ll ask you for the Holiday Schedule</b>
                            </Label>
                        </FormGroup>
                        <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                            <FormGroup>
                                <label>
                                    Please select from the following options
                                </label>

                                <Input
                                    defaultValue={props.holidayScheduleVal.amount}
                                    type="select"
                                    id="holidayschedule"
                                    onChange={(e) => setMaritalSix(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.holidayScheduleVal.amount === "0"} >We will not have a Holiday Schedule</option>
                                    <option value="1" selected={props.holidayScheduleVal.amount === "1"}>We will not specify the schedule, but agree to share holidays so that each of us receives equal custodial time either by sharing all the holidays, alternating or some other agreed to method</option>
                                    <option value="2" selected={props.holidayScheduleVal.amount === "2"}>We have a Holiday Schedule that we will include as an attachment to the MSA</option>
                                    <option value="3" selected={props.holidayScheduleVal.amount === "3"} >Other</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalSix === 3 ? true : false}>
                            <FormGroup>
                                <label>
                                    Please write in your Holiday Schedule. See the Sample MSA for sample language
                                </label>

                                <Input
                                    defaultValue={props.holidayScheduleVal.val}
                                    type="textarea"
                                    id="holidayother"
                                >

                                </Input>
                            </FormGroup>
                        </Collapse>

                    </div>

                );

            case 7:
                return (
                    <div>
                        {/* Q3 Started */}
                        <FormGroup>
                            <Label for="exampleSelect">
                                <b> Let’s work on the timeshare schedules. I’ll ask you for the Summer Schedule/Summer Vacation</b>
                            </Label>
                        </FormGroup>
                        <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                            <FormGroup>
                                <label>
                                    Let’s work on a Summer Schedule or Summer Vacation Schedule please select from the following options
                                </label>

                                <Input
                                    defaultValue={props.summerScheduleVal.amount}
                                    type="select"
                                    name="married"
                                    id="summerschedule"
                                    onChange={(e) => setMaritalSeven(JSON.parse(e.target.value))}

                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.summerScheduleVal.amount === "0"}>We will not have a Summer Schedule. (It’s not different from the Regular Schedule and we are not including any vacation time)</option>
                                    <option value="1" selected={props.summerScheduleVal.amount === "1"}>We will each receive a set number of vacation days during the holidays</option>
                                    <option value="2" selected={props.summerScheduleVal.amount === "2"} >Other</option>
                                </Input>
                            </FormGroup>
                        </div>

                        <Collapse isOpen={isMaritalSeven === 1 ? true : false}>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>
                                    <label>
                                        How many days can each parent have the child for summer vacation?
                                    </label>

                                    <Input
                                        min="1"
                                        defaultValue={isEmpty(props.summerScheduleVal.summer) ? 1 : props.summerScheduleVal.summer}
                                        type="text"
                                        name="married"
                                        id="summervacation"

                                    >

                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>
                                    <label>
                                        What is the maximum number of days the parents can have child for the summer vacation?
                                    </label>
                                    <Input

                                        defaultValue={props.summerScheduleVal.consecutive}
                                        type="text"
                                        name="married"
                                        id="consecutivedays"

                                    >
                                    </Input>
                                </FormGroup>
                            </div>
                        </Collapse>
                        <Collapse isOpen={isMaritalSeven === 2 ? true : false}>
                            <FormGroup>
                                <label>
                                    Please write in your Summer Schedule. See the Sample MSA for sample language.
                                </label>

                                <Input
                                    defaultValue={props.summerScheduleVal.other}
                                    type="textarea"
                                    name="married"
                                    id="summerother"

                                >
                                </Input>
                            </FormGroup>
                        </Collapse>

                    </div>

                );

            case 8:
                return (
                    <div>
                        {/* Q3 Started */}
                        <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>CHILD SUPPORT</h3>

                        <FormGroup>
                            <Label for="exampleSelect">
                                You must complete the required Child Support Information and Order Attachment, FL-342. Please use the form automation to complete it. If you have non-guideline child support, you will also need FL-342(a). Follow the form automation instructions to complete that as well.

                                We will also include general language in your MSA to direct the court to your FL-342.

                            </Label>

                        </FormGroup>

                    </div>

                );
            case 9:
                return (
                    <div>
                        {/* Q3 Started */}
                        <h3 style={{ paddingBottom: "10px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>SPOUSAL SUPPORT</h3>

                        <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                            <FormGroup>
                                <li><label><b>Please select one of the options for Petitioner</b></label></li>
                                <Input
                                    defaultValue={props.spousalRespondent.amount}
                                    type="select"
                                    name="married"
                                    id="spousalpet"
                                    onChange={(e) => setMaritalEight(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.spousalRespondent.amount === "0"}>Petitioner will receive spousal support from the Respondent</option>
                                    <option value="1" selected={props.spousalRespondent.amount === "1"}> Petitioner waives their right to receive spousal support from the Respondent</option>
                                    <option value="2" selected={props.spousalRespondent.amount === "2"}> Petitioner reserves their right to receive spousal support from the Respondent</option>


                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalEight === 0 ? true : false}>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>

                                    <label>How much spousal support respondent shall pay Petitioner as permanent  </label>
                                    <Row>
                                        <Col md="6">
                                            <label> <b> Per Month </b></label>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>$</InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    defaultValue={props.spousalRespondent.permanent}
                                                    type="number"
                                                    id="perpay"
                                                >
                                                </Input>
                                            </InputGroup>
                                        </Col>
                                        <Col md="6">
                                            <label> <b>Starting Date</b></label>
                                            <Input
                                                defaultValue={moment(props.spousalRespondent.date).format('YYYY-MM-DD')}
                                                type="date"
                                                name="married"
                                                id="startdate"
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>
                                    <Alert style={{
                                        backgroundColor: "#f0fbfb",
                                        color: "black",
                                        marginBottom: "20px"
                                    }} icon={false} severity="warning"><b>Next,</b> let’s put in when spousal support ends. It automatically ends with death of either party, remarriage of the Petitioner, or further court order or agreement. Other than that reason
                                    </Alert>
                                    <Input
                                        defaultValue={props.spouseShall.amount}
                                        type="select"
                                        name="married"
                                        id="spousalend"
                                        onChange={(e) => setMaritalTwelve(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1" >
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.spouseShall.amount === "0"} >Spousal support shall also end on a specified date</option>
                                        <option value="1" selected={props.spouseShall.amount === "1"}> Spousal support does not have any end date</option>
                                    </Input>

                                </FormGroup>
                            </div>
                            <Collapse isOpen={isMaritalTwelve === 0 ? true : false}>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <label><b>Date</b></label>
                                        <Input
                                            defaultValue={moment(props.spouseShall.date).format('YYYY-MM-DD')}
                                            type="date"
                                            id="petspousaldate"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                            </Collapse>
                        </Collapse>

                        <Collapse isOpen={isMaritalEight === 2 ? true : false}>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>
                                    <Alert style={{
                                        backgroundColor: "#f0fbfb",
                                        color: "black",
                                        marginBottom: "20px"
                                    }} icon={false} severity="warning"><b>Ok,</b> let’s put in when the reservation of spousal support will end.  It automatically ends with death of either party, remarriage of the Petitioner, or further court order or agreement. Other than that reason
                                    </Alert>
                                    <Input
                                        defaultValue={props.reservation.amount}
                                        type="select"
                                        name="married"
                                        id="reservation"
                                        onChange={(e) => setMaritalNine(JSON.parse(e.target.value))}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value="0" selected={props.reservation.amount === "0"}>Reservation of spousal support shall also end on a specified date</option>
                                        <option value="1" selected={props.reservation.amount === "1"}> Reservation of spousal support shall not end and remain open</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <Collapse isOpen={isMaritalNine === 0 ? true : false}>
                                <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                    <FormGroup>
                                        <label><b>Date</b> </label>
                                        <Input
                                            defaultValue={moment(props.reservation.date).format('YYYY-MM-DD')}

                                            type="date"
                                            name="married"
                                            id="resdate"
                                        >

                                        </Input>
                                    </FormGroup>
                                </div>
                            </Collapse>
                        </Collapse>
                        <div style={{ paddingTop: "10px" }}>
                            <FormGroup>
                                <li><label><b>Please select one of the options for Respondent</b></label></li>
                                <Input
                                    defaultValue={props.spousalPetitioner.amount}
                                    type="select"
                                    name="married"
                                    id="resspousal"
                                    onChange={(e) => setMaritalEleven(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.spousalPetitioner.amount === "0"} >Respondent will receive spousal support from the Petitioner</option>
                                    <option value="1" selected={props.spousalPetitioner.amount === "1"}>  Respondent waives their right to receive spousal support from the Petitioner</option>
                                    <option value="2" selected={props.spousalPetitioner.amount === "2"}>   Respondent reserves their right to receive spousal support from the Petitioner</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isMaritalEleven === 0 ? true : false}>
                            <div style={{ paddingBottom: "10px", textAlign: "justify", textJustify: "auto" }}>
                                <FormGroup>

                                    <label>How much spousal support petitioner shall pay Respondent as permanent </label>
                                    <Row>
                                        <Col md="6">
                                            <label> <b> Per Month </b></label>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>$</InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    defaultValue={props.spousalPetitioner.permanent}
                                                    type="number"
                                                    id="resperpay"
                                                >
                                                </Input>
                                            </InputGroup>
                                        </Col>
                                        <Col md="6">
                                            <label> <b>Starting Date</b></label>
                                            <Input
                                                defaultValue={moment(props.spousalPetitioner.date).format('YYYY-MM-DD')}
                                                type="date"
                                                id="resstartdate"
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                            <FormGroup>
                                <Alert style={{
                                    backgroundColor: "#f0fbfb",
                                    color: "black",
                                    marginBottom: "20px"
                                }} icon={false} severity="warning"><b>Next,</b> let’s put in when spousal support ends. It automatically ends with death of either party, remarriage of the Respondent, or further court order or agreement. Other than that reason
                                </Alert>
                                <Input
                                    defaultValue={props.spousalShall.amount}
                                    type="select"
                                    id="spousalsupport"
                                    onChange={(e) => setMaritalThirdteen(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.spousalShall.amount === "0"} >Spousal support shall also end on a specified date</option>
                                    <option value="1" selected={props.spousalShall.amount === "1"}>  Spousal support does not have any end date</option>
                                </Input>

                            </FormGroup>

                            <Collapse isOpen={isMaritalThirdteen === 0 ? true : false}>
                                <FormGroup>
                                    <label><b>Date</b></label>
                                    <Input
                                        defaultValue={moment(props.spousalShall.date).format('YYYY-MM-DD')}
                                        type="date"
                                        name="married"
                                        id="resspousaldate"
                                    >
                                    </Input>
                                </FormGroup>
                            </Collapse>
                        </Collapse>
                        <Collapse isOpen={isMaritalEleven === 2 ? true : false}>
                            <FormGroup>
                                <Alert style={{
                                    backgroundColor: "#f0fbfb",
                                    color: "black",
                                    marginBottom: "20px"
                                }} icon={false} severity="warning"><b>Next,</b> let’s put in when the reservation of spousal support will end.  It automatically ends with death of either party, remarriage of the Respondent, or further court order or agreement. Other than that reason
                                </Alert>
                                <Input
                                    defaultValue={props.resReservation.amount}
                                    type="select"
                                    id="resrevervation"
                                    onChange={(e) => setMaritalForteen(JSON.parse(e.target.value))}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0" selected={props.resReservation.amount === "0"}> Reservation of spousal support shall also end on a specified date</option>
                                    <option value="1" selected={props.resReservation.amount === "1"}> Reservation of spousal support shall not end and remain open</option>
                                </Input>

                            </FormGroup>
                            <Collapse isOpen={isMaritalForteen === 0 ? true : false}>
                                <FormGroup>
                                    <label><b>Date</b></label>
                                    <Input
                                        defaultValue={moment(props.resReservation.date).format('YYYY-MM-DD')}
                                        type="date"
                                        id="resrevervationdate"
                                        onChange={(e) => setMaritalThirdteen(JSON.parse(e.target.value))}
                                    >

                                    </Input>

                                </FormGroup>
                            </Collapse>
                        </Collapse>

                    </div>

                );





            default:
                return 'Unknown step';
        }
    }

    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        handlePostFunc();
        if (activeStep === 7) {

            handleShow();

        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (props.minorChildren.amount === 0 && prevActiveStep === 9) ? prevActiveStep - 5 :
            prevActiveStep - 1
        );
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handlePostFunc = () => {
        if (activeStep === 0) {
            props.petitionerReceice({
                divorce_id: window.localStorage.getItem("divorce_id"),
                generalProvisionsPetitioner: filter(FL, f => f != '' && Number(f) < 7),
                generalProvisionsRespondent: filter(FL, f => f != '' && Number(f) > 6 && Number(f) < 13),
                otherAssetPetitioner: inputFields.map(value => replace(value.first, /,/g, "wewewe")),
                otherAssetRespondent: inputFieldsSecond.map(value => replace(value.second, /,/g, "wewewe")),


            })
        } else if (activeStep === 1) {
            props.divisionDebts({
                divorce_id: window.localStorage.getItem("divorce_id"),
                provisionsPetitioner: filter(FL, f => f != '' && Number(f) > 12 && Number(f) < 16),
                provisionsRespondent: filter(FL, f => f != '' && Number(f) > 15 && Number(f) < 19),
                debtsPetitioner: inputFieldsThird.map(value => replace(value.third, /,/g, "wewewe")),
                assetRespondent: inputFieldsForth.map(value => replace(value.forth, /,/g, "wewewe")),
                addtionLanguage: filter(FL, f => f != '' && Number(f) > 18),
            })
        } else if (activeStep === 2) {
            props.equalizationPayment({
                divorce_id: window.localStorage.getItem("divorce_id"),
                oweEqualizationPayment: isMaritalSixteen,
                owesPayment: isMaritalSixteen === "1" ? document.getElementById("owespayment").value : "",
                spouseOwe: isMaritalSixteen === "1" ? document.getElementById("spouseowes").value : "",
                paymentDue: isMaritalSixteen === "1" ? document.getElementById("paydate").value : "",
                paymentDueDate: (isMaritalSixteen === "1" && document.getElementById("paydate").value === "1") ? (document.getElementById("paydate").value === "1" ? document.getElementById("payduedate").value : "") : "",
                paymentPlan: (isMaritalSixteen === "1" && document.getElementById("paydate").value === "0") ? document.getElementById("paydate").value === "0" ? document.getElementById("payplan").value : "" : "",
                interestAccrue: isMaritalSixteen === "1" ? document.getElementById("interest").value : "",
                accruePerAnnum: isMaritalSixteen === "1" ? document.getElementById("interest").value === "1" ? document.getElementById("perannum").value : "" : "",
            })
        } else if (activeStep === 3) {
            props.transferRetirement({
                divorce_id: window.localStorage.getItem("divorce_id"),
                transferRetirement: document.getElementById("portionretirement").value,
                requireQdro: document.getElementById("divisionassets").value,

            })
        } else if (activeStep === 4) {
            props.prentingPlan({
                minorChildren: document.getElementById("minorchildren").value === "0" ? ((setActiveStep((prevActiveStep) => prevActiveStep === 4 && prevActiveStep + 4)), document.getElementById("minorchildren").value) : document.getElementById("minorchildren").value,
                divorce_id: window.localStorage.getItem("divorce_id"),
                childData: inputFieldsFive.map((v, index) => ({ ...v, divorce_id: window.localStorage.getItem("divorce_id"), child_parent_plan_id: v.child_parent_plan_id }))
            })


        } else if (activeStep === 5) {
            props.regularSchedule({
                divorce_id: window.localStorage.getItem("divorce_id"),
                regularSchedule: document.getElementById("regular").value,
                weakOffDate: document.getElementById("regular").value === "0" ? document.getElementById("weekdate").value : 0,
                weakOffTime: document.getElementById("regular").value === "0" ? document.getElementById("weektime").value : 0,
                partyExchange: document.getElementById("regular").value === "0" ? document.getElementById("weekplace").value : 0,
                weakOfDay: document.getElementById("regular").value === "0" ? document.getElementById("select-multiple-chip").value.split(",") : 0,
                scheduleDate: document.getElementById("regular").value === "1" ? document.getElementById("scheduledate").value : 0,
                weekPetitionalShall: document.getElementById("regular").value === "1" ? document.getElementById("weekpetitional").value : 0,
                weekRespondentShall: document.getElementById("regular").value === "1" ? document.getElementById("weekrespondent").value : 0,
                alternateMonday: document.getElementById("regular").value === "1" ? document.getElementById("alternatemonday").value : 0,
                alternateWeekend: document.getElementById("regular").value === "1" ? document.getElementById("alternateweekend").value : 0,
                remainFlexible: document.getElementById("regular").value === "1" ? document.getElementById("remainflexible").value : 0,
                commencingDate: document.getElementById("regular").value === "2" ? document.getElementById("commencingdate").value : 0,
                petitionalShall: document.getElementById("regular").value === "2" ? document.getElementById("petitionalshall").value : 0,
                respondentShall: document.getElementById("regular").value === "2" ? document.getElementById("respondentshall").value : 0,
                partiesShall: document.getElementById("regular").value === "2" ? document.getElementById("partiesshall").value : 0,
                custodyShall: document.getElementById("regular").value === "2" ? document.getElementById("custodyshall").value : 0,
                parentShall: document.getElementById("regular").value === "2" ? document.getElementById("parentshall").value : 0,
                regularOther: document.getElementById("regular").value === "3" ? document.getElementById("regularother").value : 0,
            })
        } else if (activeStep === 6) {
            props.holidaySchedule({
                divorce_id: window.localStorage.getItem("divorce_id"),
                holidaySchedule: document.getElementById("holidayschedule").value,
                holidayScheduleOther: document.getElementById("holidayschedule").value === "3" ? document.getElementById("holidayother").value : "",
            })
        } else if (activeStep === 7) {
            props.summerSchedule({
                divorce_id: window.localStorage.getItem("divorce_id"),
                summerSchedule: document.getElementById("summerschedule").value,
                summerVacationDays: document.getElementById("summerschedule").value === "1" ? document.getElementById("summervacation").value : "",
                consecutiveDays: document.getElementById("summerschedule").value === "1" ? document.getElementById("consecutivedays").value : "",
                summerScheduleOther: document.getElementById("summerschedule").value === "2" ? document.getElementById("summerother").value : "",


            })
        } else if (activeStep === 9) {
            props.spousalSupport({
                divorce_id: window.localStorage.getItem("divorce_id"),
                spousalRespondent: isMaritalEight,
                permanentSpousal: isMaritalEight === "0" ? document.getElementById("perpay").value : "",
                beginDate: isMaritalEight === "0" ? document.getElementById("startdate").value : "",
                spouseShall: isMaritalTwelve,
                terminateDate: isMaritalTwelve === "0" ? document.getElementById("petspousaldate").value : "",
                reservation: isMaritalEight === "2" ? document.getElementById("reservation").value : "",
                reservationDate: isMaritalEight === "2" ? document.getElementById("reservation").value === "0" ? document.getElementById("resdate").value : "" : "",
                spousalPetitioner: isMaritalEleven,
                spousalSupport: isMaritalEleven === "0" ? document.getElementById("resperpay").value : "",
                resbeginDate: isMaritalEleven === "0" ? document.getElementById("resstartdate").value : "",
                spousalShall: isMaritalThirdteen,
                resterminateDate: isMaritalThirdteen === "0" ? document.getElementById("resspousaldate").value : "",
                resReservation: isMaritalEleven === "2" ? document.getElementById("resrevervation").value : "",
                resReservationDate: isMaritalEleven === "2" ? document.getElementById("resrevervation").value === "0" ? document.getElementById("resrevervationdate").value : "" : "",
            })
        }
    };

    return (
        <div className={classes.root}>
            {props.isFetchingGetData ? <div style={{ marginLeft: "42%", marginTop: "18%" }}>
                <Loader
                    type="Puff"
                    color="#00BFFF"
                    height={120}
                    width={120}
                />
            </div> :
                <>
                    <div style={{
                        fontStyle: "normal",
                        fontFamily: "sans-serif",
                        backgroundColor: "white",
                        textAlign: "justify",
                        textJustify: "inter-word",
                        padding: "30px 70px"
                    }}
                    >
                        <FormGroup>
                            <h3 style={{ paddingBottom: "5px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>MSA Interview!</h3>
                            <p>
                                <strong> Welcome to the Marital Settlement Agreement builder.</strong></p>
                            <p>Please follow the prompts to build your Marital Settlement Agreement (MSA). We have pre filled out your MSA with basic legal requirements. You can see the sample MSA provided to you for more.</p>
                            <p>Select options from the prompts or answer the questions. We will autofill the MSA with your responses. Use the auto-filled MSA to make any additional additions, revisions, or changes you may need. Use our sample MSA in your sample packet for additional help or for ideas on how to capture unique agreements.
                            </p>
                            <label>The MSA builder goes in the following order:</label>
                            <ol>
                                <li>Division of Property </li>
                                <li>Division of Debts </li>
                                <li>Equalization Payment</li>
                                <li>Transfer of Retirement Assets</li>
                                <li>Parenting Plan</li>
                                <li>Child Support</li>
                                <li>Spousal Support</li>
                            </ol>
                            <p>You will have the option to skip sections that do not apply to you. Your MSA will not have a section that you skip. </p>
                            <p>After you have completed the interview, you will be able to download your MSA. Please review it carefully. This is only an MSA builder and it’s your responsibility to check your agreement. You also have the ability to make revisions and add additional provisions.</p>
                            <Alert style={{
                                backgroundColor: "#f0fbfb",
                                color: "black",
                                textAlign: "justify"
                                , textJustify: "auto"
                            }} icon={false} severity="warning"><b>Hint:</b> “Check from user information, either you are petitioner or respondent”
                            </Alert>
                        </FormGroup>
                    </div>
                    <Stepper activeStep={activeStep} orientation="vertical"
                        style={{
                            fontStyle: "normal",
                            fontFamily: "sans-serif",
                            backgroundColor: "white",
                            textAlign: "justify",
                            textJustify: "inter-word",
                            padding: "20px 70px",
                        }}
                    >
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                                <StepContent>
                                    <Typography>{getStepContent(index)}</Typography>
                                    <div className={classes.actionsContainer}>
                                        <div>
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                className={classes.button}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleNext}
                                                className={classes.button}
                                            >
                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                            </Button>
                                        </div>
                                        <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%", }}>
                                            <ModalBody style={{ backgroundColor: "#d4edda" }}><b>Great!</b> We will automatically edit your Parenting Plan in your Marital Settlement Agreement with the language you selected and provided. You will be able to further revise as needed. We have also included more parenting provisions in your Parenting Plan, similar to the sample MSA. You can revise the language to meet your needs.
                                            </ModalBody>
                                            <Button
                                                style={{ width: "", color: "white", backgroundColor: "black" }}
                                                onClick={handleClose}
                                            >
                                                <b>Close</b>
                                            </Button>
                                        </Modal>
                                        <Modal isOpen={finalShow} style={{ marginTop: "300px", marginLeft: "46%", }}>
                                            <ModalBody style={{ backgroundColor: "#d4edda" }}>Please check your MSA Word document carefully. This is a template for what would work for most people. Compare against your Sample MSA. Check your MSA for spacing issues. You do not want spaces between lines or sections. The program is not able to take out the spacing between the sections and may make errors for the numerals. Finally, make sure that the last part of your MSA flows into your signature page. Currently, it is "Distribution of Assets." The signatures CANNOT be on a separate/loner page. It will get rejected. You can use /// to create needed breaks. See your Sample MSA for more.
                                            </ModalBody>
                                            <Button
                                                style={{ width: "", color: "white", backgroundColor: "black" }}
                                                onClick={() => setFinalShow(false)}
                                            >
                                                <b>Close</b>
                                            </Button>
                                        </Modal>
                                    </div>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === steps.length && (
                        <Paper square elevation={0} className={classes.resetContainer}>
                            <Typography>All steps completed - you&apos;re finished</Typography>
                            <Button onClick={handleReset} className={classes.button} color="secondary">
                                Reset
                            </Button>
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                className={classes.button}
                            >
                                Back
                            </Button>
                        </Paper>
                    )}

                    <Button
                        style={{ float: "right" }}
                        variant="contained"
                        color="primary"
                        onClick={generate}
                    >
                        Print MSA
                    </Button>
                </>
            }
        </div>
    );

};


const mapDispatchToProps = (dispatch) => {
    return {
        postData: (data) => dispatch(postData(data)),
        petitionerReceice: (data) => dispatch(petitionerReceice(data)),
        divisionDebts: (data) => dispatch(divisionDebts(data)),
        equalizationPayment: (data) => dispatch(equalizationPayment(data)),
        transferRetirement: (data) => dispatch(transferRetirement(data)),
        prentingPlan: (data) => dispatch(prentingPlan(data)),
        regularSchedule: (data) => dispatch(regularSchedule(data)),
        holidaySchedule: (data) => dispatch(holidaySchedule(data)),
        summerSchedule: (data) => dispatch(summerSchedule(data)),
        spousalSupport: (data) => dispatch(spousalSupport(data)),
        maritalSettlementGetAllData: (data) => dispatch(maritalSettlementGetAllData(data)),
    }
}

const mapStateToProps = (state, ownProps) => ({
    generalProvisionsPetitioner: state.MaritalSettlement.generalProvisionsPetitioner,
    generalProvisionsRespondent: state.MaritalSettlement.generalProvisionsRespondent,
    otherAssetPetitioner: state.MaritalSettlement.otherAssetPetitioner,
    otherAssetRespondent: state.MaritalSettlement.otherAssetRespondent,
    provisionsPetitioner: state.MaritalSettlement.provisionsPetitioner,
    provisionsRespondent: state.MaritalSettlement.provisionsRespondent,
    debtsPetitioner: state.MaritalSettlement.debtsPetitioner,
    assetRespondent: state.MaritalSettlement.assetRespondent,
    addtionLanguage: state.MaritalSettlement.addtionLanguage,
    oweEqualizationPayment: state.MaritalSettlement.oweEqualizationPayment,
    owesPayment: state.MaritalSettlement.owesPayment,
    spouseOwe: state.MaritalSettlement.spouseOwe,
    paymentDue: state.MaritalSettlement.paymentDue,
    paymentDueDate: state.MaritalSettlement.paymentDueDate,
    paymentPlan: state.MaritalSettlement.paymentPlan,
    interestAccrue: state.MaritalSettlement.interestAccrue,
    accruePerAnnum: state.MaritalSettlement.accruePerAnnum,
    transferRetirementValue: state.MaritalSettlement.transferRetirement,
    requireQdro: state.MaritalSettlement.requireQdro,
    spousalRespondent: state.MaritalSettlement.spousalRespondent,
    permanentSpousal: state.MaritalSettlement.permanentSpousal,
    beginDate: state.MaritalSettlement.beginDate,
    spouseShall: state.MaritalSettlement.spouseShall,
    terminateDate: state.MaritalSettlement.terminateDate,
    reservation: state.MaritalSettlement.reservation,
    reservationDate: state.MaritalSettlement.reservationDate,
    spousalPetitioner: state.MaritalSettlement.spousalPetitioner,
    spousalSupport: state.MaritalSettlement.spousalSupport,
    resbeginDate: state.MaritalSettlement.resbeginDate,
    spousalShall: state.MaritalSettlement.spousalShall,
    resterminateDate: state.MaritalSettlement.resterminateDate,
    resReservation: state.MaritalSettlement.resReservation,
    resReservationDate: state.MaritalSettlement.resReservationDate,
    minorChildren: state.MaritalSettlement.minorChildren,
    childData: state.MaritalSettlement.childData,
    childName: state.MaritalSettlement.childName,
    legalCustody: state.MaritalSettlement.legalCustody,
    soleCustody: state.MaritalSettlement.soleCustody,
    regularScheduleValue: state.MaritalSettlement.regularSchedule,
    weakOffDate: state.MaritalSettlement.weakOffDate,
    weakOffTime: state.MaritalSettlement.weakOffTime,
    partyExchange: state.MaritalSettlement.partyExchange,
    weakOfDay: state.MaritalSettlement.weakOfDay,
    commencingDate: state.MaritalSettlement.commencingDate,
    petitionalShall: state.MaritalSettlement.petitionalShall,
    respondentShall: state.MaritalSettlement.respondentShall,
    partiesShall: state.MaritalSettlement.partiesShall,
    custodyShall: state.MaritalSettlement.custodyShall,
    parentShall: state.MaritalSettlement.parentShall,
    scheduleDate: state.MaritalSettlement.scheduleDate,
    weekPetitionalShall: state.MaritalSettlement.weekPetitionalShall,
    weekRespondentShall: state.MaritalSettlement.weekRespondentShall,
    alternateMonday: state.MaritalSettlement.alternateMonday,
    alternateWeekend: state.MaritalSettlement.alternateWeekend,
    remainFlexible: state.MaritalSettlement.remainFlexible,
    regularOther: state.MaritalSettlement.regularOther,
    holidayScheduleVal: state.MaritalSettlement.holidaySchedule,
    holidayScheduleOther: state.MaritalSettlement.holidayScheduleOther,
    summerScheduleVal: state.MaritalSettlement.summerSchedule,
    summerVacationDays: state.MaritalSettlement.summerVacationDays,
    consecutiveDays: state.MaritalSettlement.consecutiveDays,
    summerScheduleOther: state.MaritalSettlement.summerScheduleOther,
    petitioner: state.ProfileInformationReducer.petitionerDetails,
    respondent: state.ProfileInformationReducer.respondentDetails,
    court: state.ProfileInformationReducer.court,
    dates: state.petitionerPacketReducer.dates,
    isDissolveMarriage: state.JudgementPacketFormsReducer.dissolveMarriage,
    petitionerCheck: state.ProfileInformationReducer.petitionerCheck,
    isFetchingGetData: state.MaritalSettlement.isFetchingGetData,
    marriageDate: state.MaritalSettlement.marriageDate,
    seprationDate: state.MaritalSettlement.seprationDate,

});

export default connect(mapStateToProps, mapDispatchToProps)(MaritalSettlement);
